import { useState, useEffect, useRef, useMemo } from 'react'
import { useIsNarrow } from '../../store/theme.js'
import { logEvent } from '../../store/eventLog.js'
import { todayStr, fmtDate, fmtPrice, totalSys, REFRESH_POOL, LOCATIONS, LOC_KEY, LOC_LABEL, LOC_COLOR, MOV_COLOR, MOV_ICON, MOV_LABEL, STATUS_LOG, STATUS_LOG_COLOR, STATUS_LOG_LABEL, CNPJS } from '../../data/seed.js'
import { Field, TInp, LocBtn, Overlay, ModalHead, Badge, ActionBtn, PrimaryBtn, GhostBtn, INP_STYLE } from '../shared/ui.jsx'
import { addNotification } from '../../store/notifications.js'
import { OMIE_CREDS } from '../../lib/omie.js'
import { useGlobalProducts, setGlobalProducts, saveMovimento, nextCRSku, sbAtualizarProdutoOmie, sbDispararAjusteOmie } from '../../store/products.js'
import { useGlobalTasks, setGlobalTasks, addTask } from '../../store/tasks.js'

const DEPARTAMENTOS_POR_EMPRESA={
  "CRO DIST":[{id:"5403772364",nome:"Administrativo"},{id:"5403772365",nome:"Comercial I"},{id:"5403772366",nome:"Croma Tecnologia"},{id:"5403772367",nome:"Licitação"},{id:"5408208660",nome:"Outsourcing"},{id:"5408208663",nome:"E-Commerce"},{id:"5408208665",nome:"Obra"},{id:"5408208668",nome:"Roberto - Pessoal"},{id:"5941851815",nome:"Comercial II"},{id:"6191255193",nome:"Croma SP"}],
  "CRO EQUIP":[{id:"1606561228",nome:"Administrativo"},{id:"1606561229",nome:"Comercial I"},{id:"1606561230",nome:"Croma Tecnologia"},{id:"1606561231",nome:"Licitação"},{id:"2020233955",nome:"Outsourcing"},{id:"2020233957",nome:"E-Commerce"},{id:"2109175130",nome:"Obra"},{id:"2109175133",nome:"Roberto - Pessoal"},{id:"2754679653",nome:"Comercial II"},{id:"11854557306",nome:"Croma SP"}],
  "CRO TI":[{id:"4298724272",nome:"Administrativo"},{id:"4298724273",nome:"Comercial I"},{id:"4298724274",nome:"Croma Tecnologia"},{id:"4298724275",nome:"Licitação"},{id:"4503150713",nome:"Outsourcing"},{id:"4503150715",nome:"E-Commerce"},{id:"4565062870",nome:"Obra"},{id:"4565062872",nome:"Roberto - Pessoal"},{id:"4976860973",nome:"Comercial II"}],
  "ESFERA":[{id:"1813721313",nome:"Administrativo"},{id:"1813721314",nome:"Comercial I"},{id:"1813721315",nome:"Croma Tecnologia"},{id:"1813721316",nome:"Licitação"},{id:"1962844320",nome:"Outsourcing"},{id:"1962844322",nome:"E-Commerce"},{id:"2004340574",nome:"Obra"},{id:"2042408276",nome:"Roberto - Pessoal"},{id:"2311882149",nome:"Croma SP"},{id:"11150365457",nome:"Comercial II"},{id:"11243032161",nome:"Comercial"}],
  "CFM DIST":[{id:"8410952999",nome:"CFM Distribuidora"},{id:"8419509532",nome:"Administrativo"},{id:"8419509698",nome:"Comercial I"},{id:"8419509951",nome:"Comercial II"},{id:"8419510161",nome:"Licitação"},{id:"8419510390",nome:"Outsourcing"},{id:"8419510573",nome:"E-Commerce"},{id:"8419510698",nome:"Obra"},{id:"8419510832",nome:"Roberto - Pessoal"},{id:"8419510929",nome:"Croma SP"}],
  "M.A. DIST":[{id:"1595223710",nome:"Administrativo"},{id:"1595223711",nome:"Comercial I"},{id:"1595223712",nome:"M.A. Distribuidora"},{id:"1595223713",nome:"Licitação"},{id:"1595224271",nome:"Outsourcing"},{id:"1595224273",nome:"E-Commerce"},{id:"1595224275",nome:"Obra"},{id:"1595224277",nome:"Roberto - Pessoal"},{id:"9200855995",nome:"Comercial II"},{id:"9495504899",nome:"Croma SP"}],
  "CRUZEIRO":[{id:"1606820361",nome:"Administrativo"},{id:"1606820364",nome:"Comercial I"},{id:"1606820368",nome:"Croma Tecnologia"},{id:"1606820371",nome:"Licitação"},{id:"2020233644",nome:"Outsourcing"},{id:"2020233646",nome:"E-Commerce"},{id:"2184702915",nome:"Obra"},{id:"2184702919",nome:"Roberto - Pessoal"},{id:"2708683063",nome:"Croma SP"},{id:"2754679692",nome:"Comercial II"}],
  "CRO TECINFO":[{id:"1896922030",nome:"Administrativo"},{id:"1896922031",nome:"Comercial I"},{id:"1896922032",nome:"Croma Tecnologia"},{id:"1896922033",nome:"Licitação"},{id:"1963710562",nome:"Outsourcing"},{id:"1963710564",nome:"E-Commerce"},{id:"2042393802",nome:"Obra"},{id:"2042393804",nome:"Roberto - Pessoal"},{id:"2311882607",nome:"Croma SP"},{id:"11170448262",nome:"Comercial II"}],
  "ESPACO":[{id:"1436651585",nome:"Administrativo"},{id:"1436651586",nome:"Comercial I"},{id:"1436651587",nome:"Croma Tecnologia"},{id:"1436651588",nome:"Licitação"},{id:"1704344402",nome:"Outsourcing"},{id:"1704344405",nome:"E-Commerce"},{id:"1778953869",nome:"Obra"},{id:"1778953871",nome:"Roberto - Pessoal"},{id:"2144481339",nome:"Comercial II"},{id:"2203263727",nome:"Comercial"},{id:"2356856611",nome:"Croma SP"}],
  "C.A.S.":[{id:"6860281208",nome:"C.A.S. Telemarketing"},{id:"6860573475",nome:"Administrativo"},{id:"6860574849",nome:"Licitação"},{id:"6860574909",nome:"Outsourcing"},{id:"6860574967",nome:"Obra"},{id:"6860575096",nome:"Roberto - Pessoal"},{id:"6860575856",nome:"Comercial I"},{id:"7083008303",nome:"Croma SP"},{id:"7083008377",nome:"Comercial II"},{id:"7083008492",nome:"E-Commerce"}],
};

const COMPRADORES_POR_EMPRESA={
  "CRO DIST":    {jadson:5408210318},   // ALAN C.
  "CRO EQUIP":   {jadson:2057987979},   // ALAN C.
  "CRO TI":      {jadson:4523413355},   // ALAN C.
  "ESFERA":      {jadson:11467036869},  // JADSON
  "CFM DIST":    {jadson:8419514290},   // ALAN C.
  "M.A. DIST":   {jadson:9531445744},   // JADSON
  "CRUZEIRO":    {jadson:2057950442},   // ALAN C.
  "CRO TECINFO": {jadson:1897266375},   // ALAN C.
  "ESPACO":      {jadson:1918312372},   // LAIS
  "C.A.S.":      {jadson:6862192719},   // FELIPE MONTEIRO
};


function MovModal({product:p,user,onClose,onSave}){
  const [type,setType]=useState("transferencia");
  const [loc,setLoc]=useState("ESFERA");
  const [from,setFrom]=useState("ESFERA");
  const [to,setTo]=useState("CROMA");
  const [qty,setQty]=useState("");
  const [note,setNote]=useState("");
  const [err,setErr]=useState("");
  const isTransfer=type==="transferencia";
  const isAjuste=type==="ajuste";
  const estoqueAtual=isAjuste?(p[LOC_KEY[loc]]||0):0;
  const novoValor=parseInt(qty)||0;
  const delta=novoValor-estoqueAtual;
  const validate=()=>{
    if(isAjuste){
      if(qty===""||isNaN(parseInt(qty)))return"Informe o estoque final desejado.";
      if(novoValor<0)return"Estoque nao pode ser negativo.";
      if(delta===0)return"Novo valor igual ao atual — nenhuma alteracao necessaria.";
      return null;
    }
    const n=parseInt(qty);
    if(!n||n<=0)return"Informe uma quantidade valida.";
    if(isTransfer){
      if(from===to)return"Origem e destino devem ser diferentes.";
      const av=p[LOC_KEY[from]]||0;
      if(n>av)return`Estoque insuficiente em ${LOC_LABEL[from]} (disponivel: ${av} un).`;
    }
    return null;
  };
  const save=()=>{
    const e=validate();if(e){setErr(e);return;}
    const n=parseInt(qty);
    if(isTransfer)onSave({type:"transferencia",from,to,qty:n,note,operator:user.name,date:todayStr()});
    else if(isAjuste)onSave({type:"ajuste",location:loc,qty:novoValor,delta,note,operator:user.name,date:todayStr()});
    else onSave({type,location:loc,qty:n,note,operator:user.name,date:todayStr()});
    onClose();
  };
  return(
    <Overlay onClose={onClose}>
      <ModalHead title="REGISTRAR MOVIMENTACAO" color="#ffa502" onClose={onClose}/>
      <p style={{color:"var(--text3)",fontSize:11,margin:"0 0 20px"}}>{p.sku} — {p.name}</p>
      <Field label="TIPO">
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {[["transferencia","TRANSFERÊNCIA"],["ajuste","AJUSTE"]].map(([v,l])=>(
            <button key={v} onClick={()=>{setType(v);setErr("");}}
              style={{flex:1,background:type===v?MOV_COLOR(v)+"28":"var(--bg)",border:type===v?`1px solid ${MOV_COLOR(v)}55`:"1px solid var(--border2)",color:type===v?MOV_COLOR(v):"var(--text4)",padding:"8px 4px",fontSize:9,cursor:"pointer",borderRadius:2,fontWeight:type===v?700:400}}>
              {MOV_ICON(v)} {l}
            </button>
          ))}
        </div>
      </Field>
      {!isTransfer&&<Field label="DEPOSITO"><div style={{display:"flex",gap:6}}>{LOCATIONS.map(k=><LocBtn key={k} locKey={k} selected={loc===k} onSelect={setLoc}/>)}</div></Field>}
      {isTransfer&&<>
        <Field label="SAIDA — ORIGEM">
          <div style={{display:"flex",gap:6}}>{LOCATIONS.map(k=><LocBtn key={k} locKey={k} selected={from===k} onSelect={v=>{setFrom(v);if(v===to)setTo(LOCATIONS.find(x=>x!==v));setErr("");}}/>)}</div>
          <p style={{fontSize:9,color:"var(--text3)",marginTop:6}}>DISPONIVEL: <span style={{color:LOC_COLOR[from],fontWeight:700}}>{p[LOC_KEY[from]]||0} un</span></p>
        </Field>
        <div style={{textAlign:"center",margin:"-2px 0 12px",fontSize:20,color:"#ffa502"}}>↓</div>
        <Field label="ENTRADA — DESTINO">
          <div style={{display:"flex",gap:6}}>{LOCATIONS.map(k=><LocBtn key={k} locKey={k} selected={to===k} disabled={k===from} onSelect={v=>{setTo(v);setErr("");}}/>)}</div>
        </Field>
        <div style={{display:"flex",alignItems:"center",gap:10,background:"var(--bg)",border:"1px solid var(--border)",borderRadius:2,padding:"10px 14px",marginBottom:14}}>
          <span style={{fontSize:11,color:LOC_COLOR[from],fontWeight:700}}>{LOC_LABEL[from]}</span>
          <span style={{color:"#ffa502",fontSize:16}}>→</span>
          <span style={{fontSize:11,color:LOC_COLOR[to],fontWeight:700}}>{LOC_LABEL[to]}</span>
        </div>
      </>}
      {isAjuste&&<div style={{background:"var(--bg)",border:"1px solid var(--border)",borderRadius:2,padding:"10px 14px",marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span style={{fontSize:10,color:"var(--text4)"}}>ATUAL: <strong style={{color:"var(--text)",fontFamily:"monospace"}}>{estoqueAtual} un</strong></span>
        {qty!==""&&delta!==0&&<span style={{fontSize:10,fontWeight:700,color:delta>0?"#00d084":"#ff4757",fontFamily:"monospace"}}>{delta>0?"+":""}{delta} un</span>}
      </div>}
      <Field label={isAjuste?"ESTOQUE FINAL DESEJADO":"QUANTIDADE"}>
        <TInp value={qty} onChange={v=>{setQty(v);setErr("");}} type="number" placeholder={isAjuste?`Atual: ${estoqueAtual}`:"0"}/>
      </Field>
      <Field label="OBSERVACAO"><TInp value={note} onChange={setNote} placeholder="NF, pedido ML, motivo..."/></Field>
      {err&&<p style={{color:"#ff4757",fontSize:11,margin:"-4px 0 12px"}}>⚠ {err}</p>}
      <PrimaryBtn onClick={save} style={{width:"100%",marginTop:4}}>CONFIRMAR</PrimaryBtn>
    </Overlay>
  );
}

function EditModal({product:p,onClose,onSave}){
  const [sku,setSku]=useState(p.sku);
  const [name,setName]=useState(p.name);
  const [price,setPrice]=useState(p.price>0?p.price:"");
  const [err,setErr]=useState("");
  const [confirm,setConfirm]=useState(null);
  const skuChanged=sku.trim().toUpperCase()!==p.sku;
  const priceChanged=(parseFloat(price)||0)!==p.price;
  const trySave=()=>{
    if(!sku.trim()){setErr("SKU nao pode ser vazio.");return;}
    if(!name.trim()){setErr("Nome nao pode ser vazio.");return;}
    setErr("");
    const fields={sku:sku.trim().toUpperCase(),name:name.trim(),price:parseFloat(price)||0};
    if(skuChanged||priceChanged)setConfirm(fields);
    else{onSave(fields);onClose();}
  };
  if(confirm)return(
    <Overlay onClose={onClose} zIndex={1001}>
      <div style={{textAlign:"center"}}>
        <div style={{fontSize:28,color:"#ffa502",marginBottom:14}}>⚠</div>
        <p style={{fontSize:12,color:"var(--text)",letterSpacing:1,marginBottom:8}}>CONFIRMAR ALTERACAO SENSIVEL</p>
        <div style={{background:"var(--bg)",border:"1px solid var(--border)",borderRadius:2,padding:12,marginBottom:20,textAlign:"left"}}>
          {skuChanged&&<p style={{fontSize:10,color:"var(--text2)",marginBottom:4}}>SKU: <span style={{color:"#ff4757",textDecoration:"line-through"}}>{p.sku}</span> → <span style={{color:"#00d084"}}>{confirm.sku}</span></p>}
          {priceChanged&&<p style={{fontSize:10,color:"var(--text2)"}}>Preco: <span style={{color:"#ff4757",textDecoration:"line-through"}}>{fmtPrice(p.price)}</span> → <span style={{color:"#00d084"}}>{fmtPrice(confirm.price)}</span></p>}
        </div>
        <p style={{fontSize:11,color:"var(--text3)",marginBottom:20}}>Voce tem certeza que deseja alterar {skuChanged&&priceChanged?"SKU e Preco":skuChanged?"o SKU":"o Preco"} do produto?</p>
        <div style={{display:"flex",gap:10}}>
          <GhostBtn onClick={()=>setConfirm(null)} style={{flex:1}}>NAO</GhostBtn>
          <PrimaryBtn onClick={()=>{onSave(confirm);onClose();}} style={{flex:2}}>SIM, CONFIRMAR</PrimaryBtn>
        </div>
      </div>
    </Overlay>
  );
  return(
    <Overlay onClose={onClose}>
      <ModalHead title="EDITAR PRODUTO" color="#3b82f6" onClose={onClose}/>
      <p style={{color:"var(--text3)",fontSize:11,margin:"0 0 20px"}}>{p.sku}</p>
      <div className="edit-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
        <Field label="SKU" required>
          <TInp value={sku} onChange={v=>{setSku(v);setErr("");}} placeholder="SKU"/>
          {skuChanged&&<p style={{fontSize:9,color:"#ffa502",marginTop:4}}>⚠ Alteracao sensivel</p>}
        </Field>
        <Field label="PRECO (R$)">
          <TInp value={price} onChange={v=>{setPrice(v);setErr("");}} type="number" placeholder="0,00"/>
          {priceChanged&&<p style={{fontSize:9,color:"#ffa502",marginTop:4}}>⚠ Alteracao sensivel</p>}
        </Field>
      </div>
      <Field label="NOME / DESCRICAO" required><TInp value={name} onChange={v=>{setName(v);setErr("");}} placeholder="Nome completo"/></Field>
      {err&&<p style={{color:"#ff4757",fontSize:11,margin:"-4px 0 12px"}}>{err}</p>}
      <div style={{display:"flex",gap:10,marginTop:4}}>
        <GhostBtn onClick={onClose} style={{flex:1}}>CANCELAR</GhostBtn>
        <PrimaryBtn onClick={trySave} color="#3b82f6" textColor="#fff" style={{flex:2}}>SALVAR</PrimaryBtn>
      </div>
    </Overlay>
  );
}

function TaskRequestModal({product:p,user,onClose}){
  const TASK_TYPES=[
    {id:"stock",label:"Confirmar contagem de estoque",color:"#3b82f6"},
    {id:"price",label:"Confirmar preco",color:"#f97316"},
    {id:"avail",label:"Confirmar disponibilidade para venda",color:"#00d084"},
    {id:"free",label:"Campo livre",color:"#a78bfa"},
  ];
  const [sel,setSel]=useState("stock");
  const [note,setNote]=useState("");
  const [sent,setSent]=useState(false);
  const send=()=>{
    const t=TASK_TYPES.find(t=>t.id===sel);
    addTask({sku:p.sku,productName:p.name,taskType:sel,taskLabel:t.label,note:note.trim(),requestedBy:user.name,color:t.color});
    setSent(true);setTimeout(onClose,1200);
  };
  if(sent)return(
    <Overlay onClose={()=>{}}>
      <div style={{textAlign:"center"}}>
        <div style={{fontSize:32,color:"#00d084",marginBottom:12}}>✓</div>
        <p style={{fontSize:12,color:"var(--text)",letterSpacing:2}}>SOLICITACAO ENVIADA</p>
      </div>
    </Overlay>
  );
  return(
    <Overlay onClose={onClose}>
      <ModalHead title="SOLICITAR CONFIRMACAO" color="#00d084" onClose={onClose}/>
      <p style={{color:"var(--text3)",fontSize:11,margin:"0 0 20px"}}>{p.sku} — {p.name}</p>
      <Field label="TIPO">
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          {TASK_TYPES.map(t=>(
            <button key={t.id} onClick={()=>setSel(t.id)}
              style={{background:sel===t.id?t.color+"22":"var(--bg)",border:sel===t.id?`1px solid ${t.color}44`:"1px solid var(--border2)",color:sel===t.id?t.color:"var(--text4)",padding:"10px 14px",fontSize:10,textAlign:"left",cursor:"pointer",borderRadius:2,fontWeight:sel===t.id?700:400}}>
              {t.label}
            </button>
          ))}
        </div>
      </Field>
      <Field label="OBSERVACAO (OPCIONAL)"><TInp value={note} onChange={setNote} placeholder="Descreva a duvida..."/></Field>
      <PrimaryBtn onClick={send} color="#00d084" style={{width:"100%",marginTop:4}}>ENVIAR SOLICITACAO</PrimaryBtn>
    </Overlay>
  );
}

function ResolveTaskModal({task,onClose,onResolve}){
  const [res,setRes]=useState("confirmed");
  const [note,setNote]=useState("");
  return(
    <Overlay onClose={onClose} zIndex={1002}>
      <ModalHead title="RESPONDER DEMANDA" color="#ffa502" onClose={onClose}/>
      <div style={{background:"var(--bg)",border:"1px solid var(--border)",borderRadius:2,padding:"12px 14px",margin:"0 0 20px"}}>
        <p style={{fontSize:10,color:task.color,fontWeight:700,marginBottom:4}}>{task.taskLabel}</p>
        <p style={{fontSize:12,color:"var(--text)"}}>{task.sku} — {task.productName}</p>
        {task.note&&<p style={{fontSize:10,color:"var(--text3)",marginTop:6}}>"{task.note}"</p>}
        <p style={{fontSize:9,color:"var(--text4)",marginTop:6}}>por {task.requestedBy} · {fmtDate(task.date)}</p>
      </div>
      <Field label="RESULTADO">
        <div style={{display:"flex",gap:6}}>
          {[["confirmed","✓ CONFIRMADO","#00d084"],["discrepancy","✗ DISCREPANCIA","#ff4757"]].map(([v,l,c])=>(
            <button key={v} onClick={()=>setRes(v)}
              style={{flex:1,background:res===v?c+"22":"var(--bg)",border:res===v?`1px solid ${c}44`:"1px solid var(--border2)",color:res===v?c:"var(--text4)",padding:"10px",fontSize:10,cursor:"pointer",borderRadius:2,fontWeight:res===v?700:400}}>
              {l}
            </button>
          ))}
        </div>
      </Field>
      <Field label="OBSERVACAO"><TInp value={note} onChange={setNote} placeholder={res==="discrepancy"?"Descreva a discrepancia...":"Observacao opcional..."}/></Field>
      <div style={{display:"flex",gap:10,marginTop:4}}>
        <GhostBtn onClick={onClose} style={{flex:1}}>CANCELAR</GhostBtn>
        <PrimaryBtn onClick={()=>{onResolve(task.id,res,note);onClose();}} color={res==="confirmed"?"#00d084":"#ff4757"} textColor={res==="confirmed"?"#000":"#fff"} style={{flex:2}}>
          {res==="confirmed"?"CONFIRMAR":"REGISTRAR DISCREPANCIA"}
        </PrimaryBtn>
      </div>
    </Overlay>
  );
}

function TasksPanel({onClose}){
  const [tasks]=useGlobalTasks();
  const [resolveTask,setResolveTask]=useState(null);
  const pending=tasks.filter(t=>t.status==="pending");
  const done=tasks.filter(t=>t.status==="done");
  const resolve=(id,res,note)=>{
    const t=tasks.find(tk=>tk.id===id);
    setGlobalTasks(prev=>prev.map(tk=>tk.id===id?{...tk,status:"done",resolution:res,resolutionNote:note,resolvedAt:todayStr()}:tk));
    if(t)logEvent({tipo_evento:"DEMANDA_RESOLVIDA",usuario:"Antônio",entidade:"DEMANDA",id_entidade:t.sku,detalhes:`${res} — ${note||"sem obs."}`});
  };
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",display:"flex",zIndex:1000}} onClick={onClose}>
      <div className="tasks-panel" style={{background:"var(--bg2)",borderLeft:"1px solid var(--border2)",width:"100%",maxWidth:480,height:"100vh",overflowY:"auto",marginLeft:"auto",paddingBottom:"env(safe-area-inset-bottom,0px)"}} onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"18px 20px",borderBottom:"1px solid var(--border)",position:"sticky",top:0,background:"var(--bg2)",zIndex:10}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:11,letterSpacing:3,color:"#ffa502",fontWeight:700}}>DEMANDAS</span>
            {pending.length>0&&<span style={{background:"#ff4757",color:"#fff",fontSize:9,padding:"2px 7px",borderRadius:99,fontWeight:700}}>{pending.length}</span>}
          </div>
          <button style={{background:"none",border:"none",color:"var(--text3)",fontSize:18,cursor:"pointer"}} onClick={onClose}>✕</button>
        </div>
        <div style={{padding:"16px 20px"}}>
          {pending.length===0&&done.length===0&&(
            <div style={{textAlign:"center",padding:"60px 0"}}>
              <div style={{fontSize:36,color:"var(--border2)",marginBottom:12}}>◎</div>
              <p style={{color:"var(--text5)",fontSize:11,letterSpacing:2}}>NENHUMA DEMANDA PENDENTE</p>
            </div>
          )}
          {pending.length>0&&<>
            <p style={{fontSize:9,letterSpacing:3,color:"var(--text4)",marginBottom:12}}>PENDENTES — {pending.length}</p>
            {pending.map(t=>(
              <div key={t.id} style={{background:"var(--bg3)",border:`1px solid ${t.color||"#ffa502"}33`,borderRadius:2,padding:14,marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                  <div>
                    <p style={{fontSize:9,color:t.color,letterSpacing:2,fontWeight:700,marginBottom:4}}>{t.taskLabel}</p>
                    <p style={{fontSize:12,color:"var(--text)",fontWeight:600}}>{t.sku}</p>
                    <p style={{fontSize:10,color:"var(--text3)",marginTop:2}}>{t.productName}</p>
                    {t.note&&<p style={{fontSize:10,color:"var(--text4)",marginTop:6,fontStyle:"italic"}}>"{t.note}"</p>}
                    <p style={{fontSize:9,color:"var(--text5)",marginTop:6}}>por {t.requestedBy} · {fmtDate(t.date)}</p>
                  </div>
                  <button onClick={()=>setResolveTask(t)} style={{background:"none",border:"1px solid #ffa50244",color:"#ffa502",padding:"5px 12px",fontSize:9,letterSpacing:2,cursor:"pointer",borderRadius:2,whiteSpace:"nowrap",flexShrink:0}}>RESPONDER</button>
                </div>
              </div>
            ))}
          </>}
          {done.length>0&&<>
            <p style={{fontSize:9,letterSpacing:3,color:"var(--text4)",marginTop:20,marginBottom:12}}>RESOLVIDAS — {done.length}</p>
            {done.map(t=>(
              <div key={t.id} style={{background:"var(--bg)",border:"1px solid var(--border)",borderRadius:2,padding:12,marginBottom:8,opacity:.7}}>
                <p style={{fontSize:9,color:t.resolution==="confirmed"?"#00d084":"#ff4757",fontWeight:700,marginBottom:2}}>{t.resolution==="confirmed"?"✓ CONFIRMADO":"✗ DISCREPANCIA"}</p>
                <p style={{fontSize:11,color:"var(--text3)"}}>{t.sku} — {t.taskLabel}</p>
                {t.resolutionNote&&<p style={{fontSize:9,color:"var(--text4)",marginTop:4}}>"{t.resolutionNote}"</p>}
              </div>
            ))}
          </>}
        </div>
      </div>
      {resolveTask&&<ResolveTaskModal task={resolveTask} onClose={()=>setResolveTask(null)} onResolve={resolve}/>}
    </div>
  );
}

function RefreshModal({products,onClose,onApply}){
  const [step,setStep]=useState("scanning");
  const [events,setEvents]=useState([]);
  useEffect(()=>{
    const t=setTimeout(()=>{
      const ws=products.filter(p=>(p.esfera+p.croma)>0);
      const picks=[];const pool=[...REFRESH_POOL];const count=2+Math.floor(Math.random()*3);
      for(let i=0;i<count&&pool.length>0;i++){
        const pi=Math.floor(Math.random()*pool.length);
        const ri=Math.floor(Math.random()*ws.length);
        picks.push({...pool[pi],sku:ws[ri].sku,productName:ws[ri].name,id:i});
        pool.splice(pi,1);
      }
      setEvents(picks);setStep("results");
    },1800);
    return()=>clearTimeout(t);
  },[]);
  const tc=t=>({entrada:"#00d084",saida:"#ff4757",transferencia:"#ffa502"}[t]||"#aaa");
  const ti=t=>({entrada:"↑",saida:"↓",transferencia:"⇄"}[t]||"•");
  if(step==="scanning")return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}@keyframes prog{from{width:0}to{width:100%}}`}</style>
      <div style={{background:"var(--bg2)",border:"1px solid var(--border2)",borderRadius:2,padding:28,maxWidth:380,width:"100%",textAlign:"center"}}>
        <div style={{fontSize:32,color:"#ffa502",marginBottom:16,display:"inline-block",animation:"spin 1s linear infinite"}}>⟳</div>
        <p style={{fontSize:11,letterSpacing:3,color:"var(--text)"}}>VARRENDO PLATAFORMAS...</p>
        <p style={{fontSize:9,color:"var(--text4)",marginTop:10,letterSpacing:2}}>MERCADO LIVRE · OMIE ERP · SISTEMA</p>
        <div style={{marginTop:20,height:2,background:"var(--border)",borderRadius:2,overflow:"hidden"}}>
          <div style={{height:"100%",background:"#ffa502",animation:"prog 1.8s ease-out forwards"}}></div>
        </div>
      </div>
    </div>
  );
  return(
    <Overlay onClose={onClose}>
      <ModalHead title="RESULTADO DO SYNC" color="#ffa502" onClose={onClose}/>
      <p style={{color:"var(--text3)",fontSize:10,margin:"0 0 20px"}}>{events.length} evento(s) detectado(s)</p>
      {events.map(ev=>(
        <div key={ev.id} style={{background:"var(--bg)",border:`1px solid ${tc(ev.type)}33`,borderRadius:2,padding:"12px 14px",marginBottom:10}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <span style={{fontSize:9,padding:"2px 8px",borderRadius:2,background:tc(ev.type)+"22",color:tc(ev.type),fontWeight:700}}>{ti(ev.type)} {ev.type.toUpperCase()}</span>
              <span style={{fontSize:10,color:"var(--text3)"}}>{ev.platform}</span>
            </div>
            <span style={{fontSize:14,fontWeight:700,color:tc(ev.type)}}>{ev.type==="saida"?"-":"+"}{ev.qty} un</span>
          </div>
          <p style={{fontSize:11,color:"var(--text)",margin:"8px 0 2px",fontWeight:600}}>{ev.sku}</p>
          <p style={{fontSize:9,color:"var(--text4)",marginTop:4}}>{ev.note}</p>
        </div>
      ))}
      <div style={{display:"flex",gap:10,marginTop:8}}>
        <GhostBtn onClick={onClose} style={{flex:1}}>IGNORAR</GhostBtn>
        <PrimaryBtn onClick={()=>{onApply(events);onClose();}} style={{flex:2}}>APLICAR MOVIMENTACOES</PrimaryBtn>
      </div>
    </Overlay>
  );
}


// OMIE_CREDS vivem exclusivamente em omie.js — importado acima
// CNPJ_DEST_MAP — mapa local para detecção de empresa pelo CNPJ destinatário da NF
const CNPJ_DEST_MAP={
  "48199148000123":"C.A.S.",
  "39771817000107":"CFM DIST",
  "39434379000183":"CRO DIST",
  "11855692000176":"CRO EQUIP",
  "33991536000175":"CRO TECINFO",
  "35828826000128":"CRO TI",
  "14452137000191":"CRUZEIRO",
  "37725824000139":"M.A. DIST",
  "28385405000104":"ESPACO",
  "05328910000111":"ESFERA",
};

const _CNPJ_ALIAS_MAP={
  "CRO EQUIP":"EQP","CRO TI":"TI","CRO DIST":"DST",
  "ESFERA":"ESF","CFM DIST":"CFM","M.A. DIST":"MA",
  "CRUZEIRO":"CRZ","CRO TECINFO":"TEC","ESPAÇO":"ESP","C.A.S.":"CAS",
};
function genAlias(e){return _CNPJ_ALIAS_MAP[e?.trim()]||"GEN";}
function genDateStr(){
  const d=new Date();
  return String(d.getDate()).padStart(2,"0")+String(d.getMonth()+1).padStart(2,"0")+String(d.getFullYear());
}

// consultarNFeOmie — consulta NF específica por chave (usado no cadastro unitário)
// Distinto do polling de ListarNF que vive em omie.js
const OMIE_PROXY_URL="https://jjndzkkwheixsdeizwsr.supabase.co/functions/v1/omie-proxy";
const SUPABASE_ANON_KEY="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpqbmR6a2t3aGVpeHNkZWl6d3NyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMxNzM5NTcsImV4cCI6MjA4ODc0OTk1N30.7D6C2GxC_4etlWGE5vXPVEaI5lPO5w1s7Zfsb8es90M";

async function consultarNFeOmie(chave,cnpjEmpresa){
  const creds=OMIE_CREDS[cnpjEmpresa];
  if(!creds||!creds.app_key||creds.app_key.startsWith("undefined"))
    return{ok:false,err:"credenciais_nao_configuradas"};
  try{
    const resp=await fetch(OMIE_PROXY_URL,{
      method:"POST",
      headers:{"Content-Type":"application/json","Authorization":`Bearer ${SUPABASE_ANON_KEY}`},
      body:JSON.stringify({
        endpoint:"produtos/recebimentonfe",
        payload:{call:"ConsultarRecebimento",app_key:creds.app_key,app_secret:creds.app_secret,param:[{cChaveNfe:chave}]}
      })
    });
    const rawText=await resp.text();
    const data=JSON.parse(rawText);
    if(data.faultstring)return{ok:false,err:data.faultstring};

    const cabec=data.cabec||{};
    const itens=(data.itensRecebimento||[]).map((it,i)=>{
      const c=it.itensCabec||{};
      const a=it.itensAjustes||{};
      return{
        idx:i,
        descricao:c.cDescricaoProduto||"Item "+(i+1),
        sku_forn:c.cCodigoProduto||"",
        ncm:c.cNCM?.replace(/\./g,"")||"",
        qty:parseFloat(c.nQtdeNFe||c.nQtde||1),
        valor_unit:parseFloat(c.nPrecoUnit||c.nValUnit||0),
        valor_total:parseFloat(c.nValTotal||0),
        cfop_entrada:a.cCFOPEntrada||"",
        unidade:c.cUnidadeNfe||a.cUnidade||"UN",
        nIdReceb:data.cabec?.nIdReceb||null,
        nSequencia:c.nSequencia||i+1,
        nIdProdutoOmie:c.nIdProduto||null,
      };
    });

    // Detecta empresa pelo CNPJ destinatário no cabeçalho
    const cnpjDestLimpo=(cabec.cCNPJ_CPF||"").replace(/\D/g,"");
    const empresaDet=CNPJ_DEST_MAP[cnpjDestLimpo]||cnpjEmpresa;

    return{
      ok:true,
      nIdReceb:data.cabec?.nIdReceb||null,
      numero_nf:cabec.nNumNFe||cabec.nNfNumero||"",
      serie:cabec.nSerie||cabec.cSerie||"",
      data_emissao:cabec.dDtEmissao||cabec.dEmissao||"",
      fornecedor:cabec.cRazaoSocial||cabec.cFornecedor||"",
      cnpj_emitente:cabec.cCNPJEmitente||chave.slice(6,20)||"",
      cnpj_destinatario:cnpjDestLimpo,
      empresa_detectada:empresaDet,
      valor_total:parseFloat(data.totais?.nValorTotal||0),
      itens,
    };
  }catch(e){return{ok:false,err:"rede_indisponivel"};}
}

async function concluirRecebimentoOmie(nIdReceb, itens, cnpjEmpresa, ncodprod_omie, departamento, valorTotal){
  const creds=OMIE_CREDS[cnpjEmpresa];
  if(!creds||!creds.app_key||creds.app_key.startsWith("undefined"))return;
  try{
    // AlterarRecebimento só se tiver departamento para registrar
try{
      const itensEditar=itens.map(it=>({
        itensIde:{nSequencia:it.nSequencia||1,cAcao:"EDITAR"},
        itensAjustes:{
          cCFOPEntrada:"2.102",
          nQtdeRecebida:parseFloat(it.qty||1),
          cNaoGerarMovEstoque:"N",
          cNaoGerarFinanceiro:"N",
        },
        itensCustoEstoque:{
          cICMSCusto:"S",cIPICusto:"S",cCOFINSCusto:"S",
          cICMSSTCusto:"S",cPISCusto:"S",
          cFreteCusto:"S",cSeguroCusto:"S",cOutrosDespCusto:"S",
        },
        itensAtualPreco:{
          cAtualizarAtuPre:"S",
          cAtualizarMaiorAtuPre:"S",
          nPercAtuPre:1.4,
        },
      }));
      const alanId=COMPRADORES_POR_EMPRESA[cnpjEmpresa]?.jadson;
      const paramAlt=Object.assign(
        {
          ide:{nIdReceb:parseInt(nIdReceb)},
          itensRecebimentoEditar:itensEditar,
          infoAdicionais:{nIdComprador:parseInt(alanId||0)},
        },
        departamento?{departamentos:[{cCodDepartamento:String(departamento),vDepartamento:parseFloat(valorTotal||0),pDepartamento:100}]}:{}
      );
      await fetch(OMIE_PROXY_URL,{
        method:"POST",
        headers:{"Content-Type":"application/json","Authorization":`Bearer ${SUPABASE_ANON_KEY}`},
        body:JSON.stringify({
          endpoint:"produtos/recebimentonfe",
          payload:{call:"AlterarRecebimento",app_key:creds.app_key,app_secret:creds.app_secret,param:[paramAlt]}
        })
      }).then(r=>r.json()).then(d=>{
        if(d.faultstring)console.warn("[OMIE] AlterarRecebimento erro:",d.faultstring);
      });
    }catch(e){console.warn("[OMIE] AlterarRecebimento falhou silenciosamente:",e);}
  // ConcluirRecebimento — move para coluna Recebido
    const resConcluir=await fetch(OMIE_PROXY_URL,{
      method:"POST",
      headers:{"Content-Type":"application/json","Authorization":`Bearer ${SUPABASE_ANON_KEY}`},
      body:JSON.stringify({
        endpoint:"produtos/recebimentonfe",
        payload:{call:"ConcluirRecebimento",app_key:creds.app_key,app_secret:creds.app_secret,
          param:[{nIdReceb:parseInt(nIdReceb),cEtapa:"60"}]}
      })
    });
    const data=await resConcluir.json();
    if(data.faultstring)console.error("[OMIE] ConcluirRecebimento erro:",data.faultstring);
  }catch(e){console.error("[OMIE] concluirRecebimento falhou:",e);}
}
function parseChaveNFe(chave){
  const c=chave.replace(/\D/g,"");
  if(c.length!==44)return null;
  const cnpj=c.slice(6,20);
  const aamm=c.slice(2,6);
  const serie=c.slice(22,25);
  const numero=c.slice(25,34);
  const ano="20"+aamm.slice(0,2);
  const mes=aamm.slice(2,4);
  return{
    chave:c,
    numero_nf:numero.replace(/^0+/,""),
    serie,
    data_emissao:`${ano}-${mes}-01`,
    cnpj_emitente:cnpj,
    cnpj_fmt:`${cnpj.slice(0,2)}.${cnpj.slice(2,5)}.${cnpj.slice(5,8)}/${cnpj.slice(8,12)}-${cnpj.slice(12,14)}`,
  };
}

function validaChave(chave){
  const c=chave.replace(/\D/g,"");
  if(c.length===0)return null;
  if(c.length<44)return"incompleta";
  if(c.length>44)return"longa";
  const pesos=[2,3,4,5,6,7,8,9];
  let soma=0;
  for(let i=42;i>=0;i--)soma+=parseInt(c[i])*pesos[(42-i)%8];
  const resto=soma%11;
  const dv=resto<2?0:11-resto;
  if(dv!==parseInt(c[43]))return"invalida";
  return"ok";
}

// ── NEW PRODUCT MODAL ─────────────────────────────────────────────────────────
function UnlockBtn({onClick,label="Editar",style:extraStyle}){
  return(
    <button onClick={onClick} style={{background:"none",border:"none",color:"#555",fontSize:9,letterSpacing:1,cursor:"pointer",textDecoration:"underline",padding:"0 0 0 8px",fontFamily:"'Courier New',monospace",...extraStyle}}>
      {label}
    </button>
  );
}

function NfField({label,val,field,nfLocked,onChange}){
  return(
    <div style={{marginBottom:10}}>
      <label style={{display:"block",fontSize:9,letterSpacing:2,color:"var(--text4)",marginBottom:4}}>{label}</label>
      {nfLocked
        ?<div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:2,padding:"8px 12px",fontSize:11,color:val?"var(--text2)":"var(--text5)",minHeight:34}}>{val||"—"}</div>
        :<input value={val} onChange={e=>onChange(field,e.target.value)} style={{...INP_STYLE,width:"100%",boxSizing:"border-box"}}/>
      }
    </div>
  );
}

function NewProductModal({onClose,onSave,onSaveLote,existingSKUs,nextSkuFn,user,onMovimento,produtos}){
  const [sku,setSku]=useState("");
  const [skuLocked,setSkuLocked]=useState(true);
  const [skuEdited,setSkuEdited]=useState(false);
  const [name,setName]=useState("");
  const [nameLocked,setNameLocked]=useState(false);
  const [price,setPrice]=useState("");
  const [priceLocked,setPriceLocked]=useState(false);
  const [endereco,setEndereco]=useState("");
  const [ncm,setNcm]=useState("");
  const [unidade,setUnidade]=useState("UN");
  const [cnpj,setCnpj]=useState("");
  const [cnpjLocked,setCnpjLocked]=useState(false);
  const [croma,setCroma]=useState("0");
  const [esfera_loc,setEsferaLoc]=useState("0");
  const [fisico,setFisico]=useState("");
  const [err,setErr]=useState("");
  const [skuObs,setSkuObs]=useState("");
  const [cnpjObs,setCnpjObs]=useState("");
  const [cnpjAutoDetected,setCnpjAutoDetected]=useState(false);
  const [departamento,setDepartamento]=useState("");
  const [nfRecebimento,setNfRecebimento]=useState({nIdReceb:null,empresa:null});
  useEffect(()=>{if(!skuEdited){const s=nextSkuFn?.(cnpj);if(s)setSku(s);}},[cnpj]);
  const [chave,setChave]=useState("");
  const [chaveStatus,setChaveStatus]=useState(null);
  const debounceRef=useRef(null);
  const consultandoRef=useRef(false);
  const [nf,setNf]=useState({numero_nf:"",serie:"",data_emissao:"",fornecedor:"",cnpj_emitente:"",valor_total:""});
  const [nfLocked,setNfLocked]=useState(true);
  const [showUnlock,setShowUnlock]=useState(false);
  const [unlockPwd,setUnlockPwd]=useState("");
  const [unlockErr,setUnlockErr]=useState("");

  // Multi-item selection
  const [itens,setItens]=useState([]);
  const [selectedItens,setSelectedItens]=useState([]);
  const [selectedItem,setSelectedItem]=useState(null);
  const [loteQtd,setLoteQtd]=useState({});
  const [loteDeposito,setLoteDeposito]=useState("CROMA");
  const [loteResultado,setLoteResultado]=useState(null);

  useEffect(()=>{
    if(debounceRef.current)clearTimeout(debounceRef.current);
    const raw=chave.replace(/\D/g,"");
    if(raw.length===0){setChaveStatus(null);return;}
    setChaveStatus("validando");
    const chaveAtual = chave;

    debounceRef.current=setTimeout(async()=>{
      if(chaveAtual !== chave) return;
      if(consultandoRef.current) return;
      consultandoRef.current = true;
      const v=validaChave(chave);
      if(v==="incompleta"){setChaveStatus("incompleta");consultandoRef.current=false;return;}
      if(v==="longa"){setChaveStatus("longa");consultandoRef.current=false;return;}
      if(v==="invalida"){setChaveStatus("invalida");consultandoRef.current=false;return;}
      const chaveConsulta = chave;
      const parsed=parseChaveNFe(chaveConsulta);
      if(!parsed){setChaveStatus("invalida");consultandoRef.current=false;return;}
      setNf(prev=>({...prev,numero_nf:parsed.numero_nf,serie:parsed.serie,data_emissao:parsed.data_emissao,cnpj_emitente:parsed.cnpj_fmt}));
      setChaveStatus("consultando");
      try{
        if(true){
        const empresas=Object.keys(OMIE_CREDS);
        let res=null;
        let empEncontrada=null;
        for(let i=0;i<empresas.length;i++){
          const emp=empresas[i];
          if(chaveConsulta!==chave)break;
          const r=await consultarNFeOmie(parsed.chave,emp);
          if(r.ok){res=r;empEncontrada=emp;break;}
          if(r.err==="rede_indisponivel"){res=r;break;}
          if(i<empresas.length-1)await new Promise(r=>setTimeout(r,800));
        }
        if(!res)res={ok:false,err:"nf_nao_encontrada"};
        if(chaveConsulta !== chave){consultandoRef.current=false;return;}
        if(res.ok){
          setNf({numero_nf:res.numero_nf||parsed.numero_nf,serie:res.serie||parsed.serie,data_emissao:res.data_emissao||parsed.data_emissao,fornecedor:res.fornecedor||"",cnpj_emitente:res.cnpj_emitente||parsed.cnpj_fmt,valor_total:res.valor_total||""});
          if(empEncontrada){setCnpj(empEncontrada);setCnpjLocked(true);setCnpjAutoDetected(true);}
          if(res.nIdReceb){setNfRecebimento({nIdReceb:res.nIdReceb,empresa:empEncontrada});}
          if(res.itens&&res.itens.length>0){
            setItens(res.itens);
            setSelectedItens(res.itens.map(i=>i.idx));
            if(res.itens.length===1){
              const it=res.itens[0];
              setName(it.descricao);setNameLocked(true);
              setPrice(it.valor_unit.toFixed(2));setPriceLocked(true);
              setSelectedItem(it.idx);
              setCroma(String(Math.floor(it.qty||0)));
              setEsferaLoc("0");
            } else {
              setName("NOMES EXTRAÍDOS");
              setNameLocked(true);
            }
          }
          if(res.itens&&res.itens.length>0&&res.itens[0].ncm)setNcm(res.itens[0].ncm);
          setChaveStatus("omie_ok");
        }else if(res.err==="credenciais_nao_configuradas"){
          setChaveStatus("sem_creds");
        }else if(res.err==="nf_nao_encontrada"){
          setChaveStatus("nf_nao_encontrada");
        }else{
          setChaveStatus("omie_err");
        }
        }
      } catch(e) {
        console.error('[consultaNF] erro silencioso:', e);
        setChaveStatus("omie_err");
      } finally {
        consultandoRef.current = false;
      }
    },1500);

    return()=>clearTimeout(debounceRef.current);
  },[chave]);

  useEffect(()=>{if(nf.numero_nf)setEtqNf(nf.numero_nf);},[nf.numero_nf]);
  useEffect(()=>{if(cnpj)setEtqEmpresa(cnpj);},[cnpj]);
  useEffect(()=>{if(name&&name!=="NOMES EXTRAÍDOS")setEtqDesc(name);},[name]);
  useEffect(()=>{
    const it=itens.find(i=>i.idx===selectedItem);
    if(it?.qty)setEtqQtd(Math.max(1,Math.floor(it.qty)));
  },[selectedItem,itens]);
  useEffect(()=>{
    if(itens.length>1&&itens[0]?.descricao)setEtqDesc(itens[0].descricao);
  },[itens]);

  const toggleItem=idx=>{
    setSelectedItens(prev=>prev.includes(idx)?prev.filter(i=>i!==idx):[...prev,idx]);
  };
  const selectItemForForm=it=>{
    setSelectedItem(it.idx);
    setName(it.descricao);setNameLocked(true);
    setPrice(it.valor_unit.toFixed(2));setPriceLocked(true);
  };

  const tryUnlock=()=>{
    const OP_PWD=import.meta.env.VITE_OPERATOR_PASSWORD;
    if(OP_PWD&&unlockPwd===OP_PWD){setNfLocked(false);setShowUnlock(false);setUnlockPwd("");setUnlockErr("");}
    else setUnlockErr("Senha incorreta.");
  };

  const unlockSku=()=>{
    if(skuLocked){setSkuLocked(false);setSkuEdited(true);}
    else{setSkuLocked(true);}
  };

  const similaridade=(a,b)=>{
    if(!a||!b)return 0;
    const na=a.toLowerCase(),nb=b.toLowerCase();
    if(na===nb)return 1;
    if(na.includes(nb)||nb.includes(na))return 0.8;
    const wa=new Set(na.split(/\s+/)),wb=new Set(nb.split(/\s+/));
    const inter=[...wa].filter(w=>wb.has(w)).length;
    return inter/Math.max(wa.size,wb.size);
  };

  const findExisting=(it,produtos)=>{
    if(it.sku_forn){
      const m=produtos.find(p=>p.sku_fornecedor&&p.sku_fornecedor===it.sku_forn);
      if(m)return m;
    }
    const m=produtos.find(p=>similaridade(p.name,it.descricao)>0.7);
    return m||null;
  };

  const findExistingItem=(it)=>{
    if(!produtos)return null;
    if(it.sku_forn){
      const m=produtos.find(p=>p.sku_fornecedor&&p.sku_fornecedor===it.sku_forn);
      if(m)return m;
    }
    const m=produtos.find(p=>p.name&&it.descricao&&p.name.toLowerCase().includes(it.descricao.toLowerCase().slice(0,10)));
    return m||null;
  };

  const save=()=>{
    // Fluxo de lote — múltiplos itens da NF
    if(itens.length>1&&onSaveLote){
      if(!cnpj){setErr("Selecione a empresa destinatária.");return;}
      // Ordenar itens alfabeticamente
      const sorted=[...itens].sort((a,b)=>a.descricao.localeCompare(b.descricao));
      const novos=[];
      const entradas=[];
      // Gera SKUs sequenciais antes do loop para evitar duplicatas
      const _alias=genAlias(cnpj);
      const _dateStr=genDateStr();
      const _reNew=new RegExp(`^${_alias}-${_dateStr}-(\\d+)$`);
      const usedNums=new Set((produtos||[]).map(p=>{const m=p.sku?.match(_reNew);return m?parseInt(m[1]):null;}).filter(n=>n!==null));
      let nextN=1;while(usedNums.has(nextN))nextN++;
      const genNextSku=()=>{while(usedNums.has(nextN))nextN++;const sk=`${_alias}-${_dateStr}-${String(nextN).padStart(5,"0")}`;usedNums.add(nextN);nextN++;return sk;};
      sorted.forEach(it=>{
        const existing=findExistingItem(it);
        const cr=parseInt(loteQtd[it.idx]?.croma)||0;
        const el=parseInt(loteQtd[it.idx]?.esfera)||0;
        const loc=loteDeposito;
        if(existing){
          entradas.push({sku:existing.sku,qty:it.qty,loc,nf_chave:chave.replace(/\D/g,""),nf_numero:nf.numero_nf,operator:user?.name||"operador"});
        }else{
          const newSku=genNextSku();
          novos.push({
            id:crypto.randomUUID(),created_at:new Date().toISOString(),
            sku:newSku,sku_fornecedor:it.sku_forn||"",
            name:it.descricao,price:it.valor_unit||0,
            croma:cr,esfera:el,fisico:cr+el,
            endereco:"",cnpj,
            nf_chave:chave.replace(/\D/g,"")||"",
            nf_numero:String(nf.numero_nf||"").replace(/\D/g,""),nf_serie:nf.serie||"",
            nf_data:nf.data_emissao||"",nf_fornecedor:nf.fornecedor||"",
            nf_cnpj_emitente:nf.cnpj_emitente||"",nf_valor:nf.valor_total||"",
            ncm:it.ncm||ncm||"",unidade:"UN",
            movements:[],
          });
        }
      });
      onSaveLote(novos,entradas);
      const _itensEtq=[
        ...novos.map(p=>({sku:p.sku,name:p.name,nf_numero:p.nf_numero,ncodprod_omie:null,qty:Math.max(1,p.croma+p.esfera)})),
        ...entradas.map(e=>{const pr=produtos?.find(x=>x.sku===e.sku);return{sku:e.sku,name:pr?.name||e.sku,nf_numero:e.nf_numero||nf.numero_nf,ncodprod_omie:pr?.ncodprod_omie||null,qty:e.qty};})
      ];
      setLoteResultado({novos:novos.length,entradas:entradas.length,itensEtq:_itensEtq});
      return;
    }
    // Fluxo unitário — item único
    if(!sku.trim()){setErr("SKU obrigatorio.");return;}
    const chaveLimpa=chave.replace(/\D/g,"");
    if(produtos?.some(p=>p.nf_chave===chaveLimpa)){
      setErr("Esta NF já foi cadastrada no sistema.");
      return;
    }
    if(existingSKUs.includes(sku.trim().toUpperCase())){setErr("SKU ja cadastrado.");return;}
    if(!name.trim()){setErr("Nome obrigatorio.");return;}
    if(!ncm.trim()){setErr("NCM obrigatorio — pesquise o codigo em ncm.fazenda.gov.br");return;}
    if(skuEdited&&!skuObs.trim()){setErr("Informe o motivo da alteração do SKU.");return;}
    if(!cnpjLocked&&cnpj&&!cnpjObs.trim()){setErr("Informe o motivo da alteração da empresa.");return;}
    const cr=parseInt(croma)||0,el=parseInt(esfera_loc)||0;
    const item=itens.find(i=>i.idx===selectedItem);
    if(skuEdited){
      logEvent({tipo_evento:"SKU_MANUAL",usuario:"Operador",entidade:"PRODUTO",id_entidade:sku.trim().toUpperCase(),detalhes:`SKU gerado automaticamente substituído por entrada manual. CR original: ${nextSkuFn?.()}. Motivo: ${skuObs}`});
    }
    onSave({
      id:crypto.randomUUID(),created_at:new Date().toISOString(),
      sku:sku.trim().toUpperCase(),sku_cr:nextSkuFn?.(),
      sku_fornecedor:item?.sku_forn||"",
      name:name.trim(),price:parseFloat(price)||0,
      croma:cr,esfera:el,
      fisico:fisico.trim()!==""?parseInt(fisico):cr+el,
      endereco:endereco.trim().toUpperCase(),cnpj,
      nf_chave:chave.replace(/\D/g,"")||"",
      nf_numero:nf.numero_nf||"",nf_serie:nf.serie||"",
      nf_data:nf.data_emissao||"",nf_fornecedor:nf.fornecedor||"",
      nf_cnpj_emitente:nf.cnpj_emitente||"",nf_valor:nf.valor_total||"",
      ncm:ncm.trim()||"",
      unidade:unidade||"UN",
      movements:[],
    });
    if(nfRecebimento.nIdReceb){
            const vTotal=parseFloat(nf.valor_total)||itens.reduce((s,i)=>s+(i.valor_total>0?i.valor_total:i.qty*i.valor_unit)||0,0)||0;
      concluirRecebimentoOmie(nfRecebimento.nIdReceb,itens,nfRecebimento.empresa||cnpj,null,departamento,vTotal);
    }
    onClose();
  };

  const CHAVE_UI={
    null:      {cor:null,      msg:null},
    validando: {cor:"#ffa502", msg:"⟳ verificando..."},
    incompleta:{cor:"#ffa502", msg:`${chave.replace(/\D/g,"").length}/44 dígitos`},
    longa:     {cor:"#ff4757", msg:"⚠ mais de 44 dígitos"},
    invalida:  {cor:"#ff4757", msg:"⚠ chave inválida — verifique o código"},
    ok:        {cor:"#00d084", msg:"✓ chave válida — dados extraídos"},
    consultando:{cor:"#3b82f6", msg:"⟳ consultando SEFAZ/Omie..."},
    omie_ok:   {cor:"#00d084", msg:"✓ dados puxados do Omie via SEFAZ"},
    omie_err:  {cor:"#ffa502", msg:"⚠ Omie indisponível — dados extraídos localmente"},
    sem_creds:     {cor:"#a78bfa", msg:"⚙ configure as credenciais Omie em OMIE_CREDS"},
    nf_nao_encontrada: {cor:"#ffa502", msg:"⚠ NF não localizada em nenhuma empresa — preencha manualmente"},
  };
  const cui=CHAVE_UI[chaveStatus]||CHAVE_UI[null];



  return(
    <Overlay onClose={onClose} wide={true}>
      <ModalHead title="NOVO PRODUTO" color="#00d084" onClose={onClose}/>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 28px",alignItems:"start"}}>

        {/* ── ESQUERDA ── */}
        <div>
          {/* Chave NF-e */}
          <div style={{marginBottom:14}}>
            <label style={{display:"block",fontSize:9,letterSpacing:2,color:"var(--text4)",marginBottom:4}}>CHAVE DE ACESSO NF-e</label>
            <input value={chave} onChange={e=>setChave(e.target.value)} disabled={chaveStatus==="consultando"}
              placeholder="Escaneie ou digite os 44 dígitos..."
              autoFocus /* UX Fix: Foco automático para o leitor de código de barras */
              style={{...INP_STYLE,width:"100%",boxSizing:"border-box",
                borderColor:chaveStatus==="invalida"||chaveStatus==="longa"?"#ff475755":
                            chaveStatus==="omie_ok"||chaveStatus==="ok"?"#00d08455":"var(--border2)"}}/>
            {cui.msg&&<p style={{fontSize:9,color:cui.cor,marginTop:5,letterSpacing:1}}>{cui.msg}</p>}
          </div>

          {/* SKU */}
          <div style={{marginBottom:14}}>
            <label style={{display:"block",fontSize:9,letterSpacing:2,color:"var(--text4)",marginBottom:4}}>
              SKU INTERNO
              <UnlockBtn 
                onClick={() => {
                  if (!skuLocked) {
                    // Se estava editando e clicou para trancar: tranca e limpa os avisos
                    setSkuLocked(true);
                    setSkuObs("");
                    setSkuEdited(false);
                  } else {
                    // Se estava trancado e clicou para abrir: roda a sua função original
                    unlockSku();
                  }
                }} 
                label={skuLocked ? "Bloqueado" : "Editando"}
              />
            </label>
            <input value={itens.length>1&&produtos?(()=>{
              const used=new Set((produtos).map(p=>{const m=p.sku?.match(/^CR(\d+)$/);return m?parseInt(m[1]):null;}).filter(n=>n!==null));
              let n=1;const preview=[];
              const novosCount=[...itens].sort((a,b)=>a.descricao.localeCompare(b.descricao)).filter(it=>!findExistingItem(it)).length;
              for(let i=0;i<novosCount;i++){while(used.has(n))n++;used.add(n);preview.push("CR"+String(n).padStart(Math.max(4,String(n).length),"0"));n++;}
              return preview.join(", ");
            })():sku} onChange={e=>{if(itens.length<=1){setSku(e.target.value);setErr("");}}}
              disabled={skuLocked||itens.length>1}
              style={{...INP_STYLE,width:"100%",boxSizing:"border-box",opacity:(skuLocked||itens.length>1)?0.6:1,cursor:(skuLocked||itens.length>1)?"not-allowed":"text"}}/>
            {itens.length>1&&produtos&&(()=>{
              const used=new Set((produtos).map(p=>{const m=p.sku?.match(/^CR(\d+)$/);return m?parseInt(m[1]):null;}).filter(n=>n!==null));
              let n=1;const preview=[];
              const novosCount=[...itens].sort((a,b)=>a.descricao.localeCompare(b.descricao)).filter(it=>!findExistingItem(it)).length;
              for(let i=0;i<novosCount;i++){while(used.has(n))n++;used.add(n);preview.push("CR"+String(n).padStart(Math.max(4,String(n).length),"0"));n++;}
              return preview.length>0?null:null;
            })()}
            {skuEdited&&<>
              <p style={{fontSize:9,color:"#ffa502",marginTop:4}}>⚠ SKU manual — será registrado na auditoria. CR original: {nextSkuFn?.()}</p>
              <input value={skuObs} onChange={e=>setSkuObs(e.target.value)}
                placeholder="Motivo da alteração do SKU (obrigatório)..."
                style={{...INP_STYLE,width:"100%",boxSizing:"border-box",marginTop:6,borderColor:skuObs.trim()?"var(--border2)":"#ff475755"}}/>
            </>}
          </div>

          {/* Nome */}
          <div style={{marginBottom:14}}>
            <label style={{display:"block",fontSize:9,letterSpacing:2,color:"var(--text4)",marginBottom:4}}>
              NOME E/OU DESCRIÇÃO DO ITEM{!nameLocked&&<span style={{color:"#ff4757"}}> *</span>}
              {nameLocked&&<UnlockBtn onClick={()=>setNameLocked(false)}/>}
            </label>
            <input value={name} onChange={e=>{setName(e.target.value);setErr("");}}
            disabled={nameLocked || chaveStatus==="consultando"}
              placeholder="Ex: Notebook Lenovo Ideapad Slim 3 I5 16gb 512gb"
              style={{...INP_STYLE,width:"100%",boxSizing:"border-box",opacity:nameLocked?0.6:1,cursor:nameLocked?"not-allowed":"text"}}/>
          </div>

          {/* Preço */}
          <div style={{marginBottom:14}}>
            <label style={{display:"block",fontSize:9,letterSpacing:2,color:"var(--text4)",marginBottom:4}}>
              PREÇO (R$)
              {priceLocked&&<UnlockBtn onClick={()=>setPriceLocked(false)}/>}
            </label>
            <input value={price} onChange={e=>setPrice(e.target.value)} type="number"
            disabled={priceLocked || chaveStatus==="consultando"}
              placeholder="0,00"
              style={{...INP_STYLE,width:"100%",boxSizing:"border-box",opacity:priceLocked?0.6:1,cursor:priceLocked?"not-allowed":"text"}}/>
          </div>

          <Field label="SITUADO EM"><TInp value={endereco} onChange={v=>setEndereco(v)} placeholder="Ex: A3, B12, C1"/></Field>
          <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:8,marginBottom:14}}>
            <div>
              <label style={{display:"block",fontSize:9,letterSpacing:2,color:"var(--text4)",marginBottom:4}}>NCM{!ncm&&<span style={{color:"#ff4757"}}> *</span>}</label>
              <input value={ncm} onChange={e=>setNcm(e.target.value)} placeholder="Ex: 84719090"
                style={{...INP_STYLE,width:"100%",boxSizing:"border-box",borderColor:ncm?"var(--border2)":"#ff475733"}}/>
            </div>
            <div>
              <label style={{display:"block",fontSize:9,letterSpacing:2,color:"var(--text4)",marginBottom:4}}>UNIDADE</label>
              <select value={unidade} onChange={e=>setUnidade(e.target.value)} style={{...INP_STYLE,width:"100%",boxSizing:"border-box"}}>
                {["UN","CX","PC","KG","MT","LT","PR","JG"].map(u=><option key={u} value={u}>{u}</option>)}
              </select>
            </div>
          </div>

          {/* CNPJ */}
          <div style={{marginBottom:14}}>
            <label style={{display:"block",fontSize:9,letterSpacing:2,color:"var(--text4)",marginBottom:4}}>
              CNPJ / EMPRESA
              <UnlockBtn onClick={()=>{if(!cnpjAutoDetected)setCnpjLocked(v=>!v);}} label={cnpjLocked?"Bloqueado":"Editando"} style={{opacity:cnpjAutoDetected?0.4:1,cursor:cnpjAutoDetected?"default":"pointer"}}/>
            </label>
            {cnpjLocked&&cnpj
              ?<div style={{background:"var(--bg)",border:"1px solid #a78bfa44",borderRadius:2,padding:"10px 14px",fontSize:11,color:"#a78bfa",fontWeight:700}}>
                  {cnpj} <span style={{fontSize:9,color:"var(--text5)",fontWeight:400}}>— detectado pela NF</span>
                </div>
              :<select id="cnpj-empresa" aria-label="CNPJ / Empresa" value={cnpj} onChange={e=>setCnpj(e.target.value)} style={{...INP_STYLE}}>
                  <option value="">— Selecionar —</option>
                  {CNPJS.map(c=><option key={c} value={c}>{c}</option>)}
                </select>
            }
          </div>
          {!cnpjLocked&&cnpj&&<input value={cnpjObs} onChange={e=>setCnpjObs(e.target.value)}
            placeholder="Motivo da alteração da empresa (obrigatório)..."
            style={{...INP_STYLE,width:"100%",boxSizing:"border-box",marginTop:6,borderColor:cnpjObs.trim()?"var(--border2)":"#ff475755"}}/>}

          <Field label="DEPARTAMENTO OMIE">
            {(()=>{const depts=DEPARTAMENTOS_POR_EMPRESA[cnpj]||[];return(
              <select value={departamento} onChange={e=>setDepartamento(e.target.value)}
                style={{...INP_STYLE,width:"100%",boxSizing:"border-box",marginBottom:14}}
                disabled={!cnpj||depts.length===0}>
                <option value="">{!cnpj?"— Selecione a empresa primeiro —":depts.length===0?"— Sem departamentos mapeados —":"— Selecionar —"}</option>
                {depts.map(d=><option key={d.id} value={d.id}>{d.nome}</option>)}
              </select>
            );})()}
          </Field>

          {itens.length<=1&&<Field label="ESTOQUE FÍSICO">
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              {[["CROMA",croma,setCroma,"#f97316"],["ESFERA LOCAÇÃO",esfera_loc,setEsferaLoc,"#3b82f6"]].map(([lbl,val,set,c])=>(
                <div key={lbl} style={{background:"var(--bg)",border:`1px solid ${c}33`,borderRadius:2,padding:"10px"}}>
                  <label style={{display:"block",fontSize:9,letterSpacing:2,color:c,marginBottom:6}}>{lbl}</label>
                  <input style={{...INP_STYLE,textAlign:"center",padding:"8px"}} type="number" min="0" value={val} onChange={e=>set(e.target.value)}/>
                </div>
              ))}
            </div>
          </Field>}
        </div>

        {/* ── DIREITA — bloco NF ── */}
        <div style={{background:"var(--bg)",border:"1px solid var(--border2)",borderRadius:2,padding:16}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
            <p style={{fontSize:9,letterSpacing:3,color:"#a78bfa",fontWeight:700}}>NOTA FISCAL</p>
            <UnlockBtn onClick={()=>nfLocked?setShowUnlock(true):setNfLocked(true)} label={nfLocked?"Bloqueado":"Editando"}/>
          </div>

          {showUnlock&&(
            <div style={{background:"var(--bg2)",border:"1px solid #a78bfa44",borderRadius:2,padding:12,marginBottom:14}}>
              <p style={{fontSize:9,letterSpacing:2,color:"#a78bfa",marginBottom:8}}>SENHA DO OPERADOR</p>
              <input type="password" value={unlockPwd} onChange={e=>{setUnlockPwd(e.target.value);setUnlockErr("");}}
                onKeyDown={e=>e.key==="Enter"&&tryUnlock()} placeholder="Digite sua senha..."
                style={{...INP_STYLE,width:"100%",boxSizing:"border-box",marginBottom:8}} autoFocus/>
              {unlockErr&&<p style={{fontSize:9,color:"#ff4757",marginBottom:8}}>⚠ {unlockErr}</p>}
              <div style={{display:"flex",gap:6}}>
                <GhostBtn onClick={()=>{setShowUnlock(false);setUnlockPwd("");setUnlockErr("");}} style={{flex:1}}>CANCELAR</GhostBtn>
                <PrimaryBtn onClick={tryUnlock} color="#a78bfa" textColor="#fff" style={{flex:2}}>DESBLOQUEAR</PrimaryBtn>
              </div>
            </div>
          )}

          {chaveStatus===null
            ?<div style={{textAlign:"center",padding:"30px 0"}}>
                <div style={{fontSize:28,color:"var(--border2)",marginBottom:8}}>◈</div>
                <p style={{fontSize:9,color:"var(--text5)",letterSpacing:2,lineHeight:1.8}}>Escaneie a chave NF-e<br/>para preencher automaticamente</p>
              </div>
            :<>
              <NfField nfLocked={nfLocked} onChange={(f,v)=>setNf(prev=>({...prev,[f]:v}))} label="Nº NF"          val={nf.numero_nf}    field="numero_nf"/>
              <NfField nfLocked={nfLocked} onChange={(f,v)=>setNf(prev=>({...prev,[f]:v}))} label="SÉRIE"           val={nf.serie}        field="serie"/>
              <NfField nfLocked={nfLocked} onChange={(f,v)=>setNf(prev=>({...prev,[f]:v}))} label="DATA EMISSÃO"    val={nf.data_emissao} field="data_emissao"/>
              <NfField nfLocked={nfLocked} onChange={(f,v)=>setNf(prev=>({...prev,[f]:v}))} label="FORNECEDOR"      val={nf.fornecedor}   field="fornecedor"/>
              <NfField nfLocked={nfLocked} onChange={(f,v)=>setNf(prev=>({...prev,[f]:v}))} label="CNPJ EMITENTE"   val={nf.cnpj_emitente} field="cnpj_emitente"/>
              <NfField nfLocked={nfLocked} onChange={(f,v)=>setNf(prev=>({...prev,[f]:v}))} label="VALOR TOTAL (R$)" val={nf.valor_total?`R$ ${parseFloat(nf.valor_total).toLocaleString("pt-BR",{minimumFractionDigits:2})}`:""}  field="valor_total"/>
              <div style={{marginTop:8,padding:"8px 10px",background:"var(--bg2)",borderRadius:2,border:"1px solid var(--border)"}}>
                <p style={{fontSize:7,color:"var(--text5)",letterSpacing:1,wordBreak:"break-all",lineHeight:1.6}}>{chave.replace(/\D/g,"")}</p>
              </div>

              {/* Itens da NF */}
              {itens.length>0&&(
                <div style={{marginTop:14}}>
                  {itens.length>1?(
                    <>
                      {itens.length===1&&(chaveStatus==="omie_ok"||chaveStatus==="omie_err")&&(()=>{
                        const it=itens[0];
                        const ex=findExistingItem(it);
                        return(
                          <div style={{background:"var(--bg2)",border:"1px solid #a78bfa22",borderRadius:2,padding:"6px 10px",marginBottom:8,fontSize:8,color:"var(--text4)",fontFamily:"'Courier New',monospace",lineHeight:1.5}}>
                            {ex
                              ?<>→ entrada em <strong style={{color:"#a78bfa"}}>{ex.sku}</strong> — {ex.name}{ex.ncodprod_omie&&<span style={{color:"#a78bfa77"}}> | Omie: #{ex.ncodprod_omie}</span>}</>
                              :<>→ novo cadastro{it.nIdProdutoOmie&&<span style={{color:"#a78bfa77"}}> | produto Omie: #{it.nIdProdutoOmie}</span>}</>
                            }
                          </div>
                        );
                      })()}
                      <p style={{fontSize:9,letterSpacing:2,color:"var(--text4)",marginBottom:8}}>ITENS DA NOTA — {itens.length} itens</p>
                      <div style={{marginBottom:10}}>
                        <label style={{fontSize:9,letterSpacing:2,color:"var(--text4)",display:"block",marginBottom:4}}>DEPOSITO DE ENTRADA</label>
                        <div style={{display:"flex",gap:6}}>
                          {LOCATIONS.map(k=>(
                            <button key={k} onClick={()=>setLoteDeposito(k)}
                              style={{flex:1,padding:"6px 4px",fontSize:9,cursor:"pointer",borderRadius:2,
                                background:loteDeposito===k?LOC_COLOR[k]+"28":"var(--bg2)",
                                border:loteDeposito===k?`1px solid ${LOC_COLOR[k]}55`:"1px solid var(--border)",
                                color:loteDeposito===k?LOC_COLOR[k]:"var(--text4)",fontWeight:loteDeposito===k?700:400}}>
                              {LOC_LABEL[k]}
                            </button>
                          ))}
                        </div>
                      </div>
                      {[...itens].sort((a,b)=>a.descricao.localeCompare(b.descricao)).map(it=>{
                        const existing=findExistingItem(it);
                        return(
                          <div key={it.idx} style={{background:"var(--bg2)",border:`1px solid ${existing?"#a78bfa33":"var(--border)"}`,borderRadius:2,padding:"8px 10px",marginBottom:6}}>
                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:existing?4:6}}>
                              <p style={{fontSize:10,color:"var(--text)",fontWeight:600,flex:1,lineHeight:1.3}}>{it.descricao}</p>
                              <span style={{fontSize:8,color:"#00d084",fontWeight:700,flexShrink:0}}>R$ {it.valor_unit.toFixed(2).replace(".",",")}</span>
                            </div>
                            {existing?(
                              <p style={{fontSize:8,color:"#a78bfa",marginBottom:4}}>
                                Entrada em: <strong>{existing.sku}</strong> — {existing.name}
                                {existing.ncodprod_omie&&<span style={{color:"#a78bfa55",fontFamily:"'Courier New',monospace"}}> | Omie: #{existing.ncodprod_omie}</span>}
                              </p>
                            ):(
                              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                                {[["CROMA","croma","#f97316"],["ESFERA","esfera","#3b82f6"]].map(([lbl,key,cor])=>(
                                  <div key={key} style={{background:"var(--bg)",border:`1px solid ${cor}33`,borderRadius:2,padding:"6px 8px"}}>
                                    <label style={{display:"block",fontSize:8,color:cor,marginBottom:3}}>{lbl}</label>
                                    <input type="number" min="0" placeholder="0"
                                      value={
                                        loteQtd[it.idx]?.[key] ??
                                        (key==="croma" ? String(Math.floor(it.qty||0)) : "0")
                                      }
                                      onChange={e=>setLoteQtd(prev=>({...prev,[it.idx]:{...prev[it.idx],[key]:e.target.value}}))}
                                      style={{...INP_STYLE,padding:"4px 6px",fontSize:10,textAlign:"center",width:"100%",boxSizing:"border-box"}}/>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </>
                  ):(
                    <>
                      <p style={{fontSize:9,letterSpacing:2,color:"var(--text4)",marginBottom:8}}>ITEM DA NOTA</p>
                      {itens.map(it=>(
                        <div key={it.idx} onClick={()=>selectItemForForm(it)}
                          style={{display:"flex",alignItems:"flex-start",gap:10,padding:"8px 10px",background:selectedItem===it.idx?"#00d08415":"var(--bg2)",border:`1px solid ${selectedItem===it.idx?"#00d08444":"var(--border)"}`,borderRadius:2,marginBottom:6,cursor:"pointer"}}>
                          <div style={{flex:1,minWidth:0}}>
                            <p style={{fontSize:10,color:"var(--text)",fontWeight:selectedItem===it.idx?700:400,marginBottom:2,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{it.descricao}</p>
                            <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                              {it.sku_forn&&<span style={{fontSize:8,color:"var(--text4)"}}>CÓD: {it.sku_forn}</span>}
                              <span style={{fontSize:8,color:"var(--text4)"}}>Qtd: {it.qty}</span>
                              <span style={{fontSize:8,color:"#00d084",fontWeight:700}}>R$ {it.valor_unit.toFixed(2).replace(".",",")}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              )}
            </>
          }
        </div>
      </div>


      {loteResultado?(
        <div style={{marginTop:16,background:"#00d08410",border:"1px solid #00d08433",borderRadius:2,padding:"14px 16px"}}>
          <p style={{fontSize:11,color:"#00d084",fontWeight:700,marginBottom:6}}>Lote processado com sucesso.</p>
          <p style={{fontSize:10,color:"var(--text3)"}}>{loteResultado.novos} produto(s) cadastrado(s)</p>
          <p style={{fontSize:10,color:"var(--text3)"}}>{loteResultado.entradas} entrada(s) registrada(s)</p>
        <PrimaryBtn onClick={onClose} color="#00d084" style={{width:"100%",marginTop:12}}>FECHAR</PrimaryBtn>
      </div>
      ):(
        <>
          {err&&<p style={{color:"#ff4757",fontSize:11,margin:"12px 0 0"}}>⚠ {err}</p>}
          <div style={{display:"flex",gap:10,marginTop:16}}>
            <GhostBtn onClick={onClose} style={{flex:1}}>CANCELAR</GhostBtn>
            <PrimaryBtn onClick={save} disabled={chaveStatus==="consultando"} color="#00d084" style={{flex:2}}>
              {chaveStatus==="consultando"
                ?"AGUARDANDO..."
                :itens.length>1?`CADASTRAR ${itens.length} ITENS`:"CADASTRAR"}
            </PrimaryBtn>
          </div>
        </>
      )}
    </Overlay>
  );
}


function Card({product:init,user}){
  const [p,setP]=useState(init);
  const [open,setOpen]=useState(false);
  const [modal,setModal]=useState(false);
  const [editModal,setEditModal]=useState(false);
  const [taskModal,setTaskModal]=useState(false);
  const [showHist,setShowHist]=useState(false);
  const sys=totalSys(p);const diff=p.fisico-sys;
  const status=sys===0?"zero":sys<=3?"low":"ok";
  const sc={zero:"#ff4757",low:"#ffa502",ok:"#00d084"}[status];
  const sl={zero:"SEM ESTOQUE",low:"ESTOQUE BAIXO",ok:"EM ESTOQUE"}[status];
  const saveMovement=mv=>{
    // Atualiza estado local imediatamente (UX responsivo)
    setP(prev=>{
      const next={...prev};
      if(mv.type==="transferencia"){
        const fk=LOC_KEY[mv.from],tk=LOC_KEY[mv.to];
        next[fk]=Math.max(0,(prev[fk]||0)-mv.qty);
        next[tk]=(prev[tk]||0)+mv.qty;
      }else{
        const key=LOC_KEY[mv.location];
        const delta=mv.type==="entrada"?mv.qty:mv.type==="saida"?-mv.qty:mv.type==="ajuste"?mv.delta:0;
        if(key)next[key]=Math.max(0,(prev[key]||0)+delta);
      }
      next.movements=[mv,...prev.movements];
      return next;
    });
    // Persiste no Supabase via saveMovimento (movimentacoes + upsert produto)
    saveMovimento(p.id,mv,prev=>{
      const next={...prev};
      if(mv.type==="transferencia"){
        const fk=LOC_KEY[mv.from],tk=LOC_KEY[mv.to];
        next[fk]=Math.max(0,(prev[fk]||0)-mv.qty);
        next[tk]=(prev[tk]||0)+mv.qty;
      }else{
        const key=LOC_KEY[mv.location];
        const delta=mv.type==="entrada"?mv.qty:mv.type==="saida"?-mv.qty:mv.type==="ajuste"?mv.delta:0;
        if(key)next[key]=Math.max(0,(prev[key]||0)+delta);
      }
      next.movements=[mv,...(prev.movements||[])];
      return next;
    });
    logEvent({tipo_evento:mv.type.toUpperCase(),usuario:mv.operator||"operador",entidade:"PRODUTO",id_entidade:p.sku,detalhes:`${mv.type==='transferencia'?`${mv.from}→${mv.to}`:mv.location} | ${mv.type==="ajuste"?`${mv.qty}un (delta: ${mv.delta>0?"+":""}${mv.delta})`:mv.qty+"un"}${mv.note?` | ${mv.note}`:''}`});
  };
  const saveEdit=fields=>{
    setP(prev=>{
      const h=prev.editHistory||[];
      const entry={date:todayStr(),...fields};
      if(fields.sku!==prev.sku)entry.oldSku=prev.sku;
      if(fields.name!==prev.name)entry.oldName=prev.name;
      if(fields.price!==prev.price)entry.oldPrice=prev.price;
      const updated={...prev,...fields,editHistory:[entry,...h]};
      setGlobalProducts(all=>all.map(x=>x.sku===prev.sku?updated:x));
      sbAtualizarProdutoOmie(prev, fields);
      const tipoEdicao=(fields.price!==prev.price||fields.sku!==prev.sku)?"EDICAO_SENSIVEL":"EDICAO";
      logEvent({tipo_evento:tipoEdicao,usuario:"operador",entidade:"PRODUTO",id_entidade:prev.sku,detalhes:Object.keys(fields).filter(k=>k!=='editHistory').map(k=>`${k}: ${prev[k]}→${fields[k]}`).join(' | ')});
      return updated;
    });
  };
  return(
    <>
      <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:2}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"18px 18px 8px",flexWrap:"wrap",gap:8}}>
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
            <span style={{fontSize:12,fontWeight:700,letterSpacing:2,color:"#ffa502"}}>{p.sku}</span>
            <Badge color={sc}>{sl}</Badge>
            {(p.editHistory||[]).length>0&&<span onClick={()=>setShowHist(v=>!v)} style={{fontSize:9,padding:"2px 8px",border:"1px solid #3b82f633",borderRadius:2,background:"#3b82f618",color:"#3b82f6",cursor:"pointer"}}>✎ {(p.editHistory||[]).length}</span>}
          </div>
          <div style={{fontSize:22,fontWeight:700,color:sc,fontFamily:"monospace"}}>{sys} <span style={{fontSize:10,color:"var(--text3)",fontWeight:400}}>sistema</span></div>
        </div>
        <div style={{padding:"0 18px 6px"}}>
        <p style={{
          fontSize:12,
          color:"var(--text)",
          fontWeight:600,
          lineHeight:1.3
        }}>
          {p.name || "—"}
        </p>
      </div>
        {p.nf_numero && (
          <p style={{margin:"0 18px 6px",fontSize:9,color:"var(--text4)",letterSpacing:1}}>
            NF:{String(p.nf_numero).padStart(9,"0")} {p.nf_fornecedor?`— ${p.nf_fornecedor}`:""}
          </p>
        )}
        {p.price>0&&<p style={{margin:"0 18px 12px",fontSize:10,color:"var(--text4)"}}>PRECO <strong style={{color:"var(--text2)"}}>{fmtPrice(p.price)}</strong></p>}
        {showHist&&(p.editHistory||[]).length>0&&(
          <div style={{margin:"0 18px 12px",background:"var(--bg)",border:"1px solid #3b82f622",borderRadius:2,padding:"10px 14px"}}>
            <p style={{fontSize:9,letterSpacing:3,color:"#3b82f6",marginBottom:8}}>HISTORICO DE EDICOES</p>
            {(p.editHistory||[]).map((h,i)=>(
              <div key={i} style={{padding:"6px 0",borderBottom:i<(p.editHistory.length-1)?"1px solid var(--border)":"none",flexWrap:"wrap",display:"flex",gap:8}}>
                <span style={{fontSize:9,color:"var(--text4)",minWidth:60}}>{fmtDate(h.date)}</span>
                {h.oldSku&&<span style={{fontSize:9,color:"var(--text2)"}}>SKU: <span style={{color:"#ff4757",textDecoration:"line-through"}}>{h.oldSku}</span>→<span style={{color:"#00d084"}}>{h.sku}</span></span>}
                {h.oldName&&<span style={{fontSize:9,color:"var(--text2)"}}>Nome atualizado</span>}
                {h.oldPrice!==undefined&&<span style={{fontSize:9,color:"var(--text2)"}}>Preco: <span style={{color:"#ff4757",textDecoration:"line-through"}}>{fmtPrice(h.oldPrice)}</span>→<span style={{color:"#00d084"}}>{fmtPrice(h.price)}</span></span>}
              </div>
            ))}
          </div>
        )}
        <div style={{padding:"0 18px 14px"}}>
          <div style={{
            display:"flex",
            justifyContent:"space-between",
            alignItems:"center",
            margin:"0 0 6px"
          }}>
            <span style={{fontSize:9,letterSpacing:3,color:"var(--text5)"}}>
              SITUADO EM
            </span>
            <span style={{
              fontSize:11,
              color:"var(--text)",
              fontFamily:"monospace"
            }}>
              {p.endereco || "—"}
            </span>
          </div>

          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0 0 10px"
          }}>
            <span style={{ fontSize: 9, letterSpacing: 3, color: "var(--text5)" }}>
              REGISTRADO EM
            </span>
            <span style={{
              fontSize: 10,
              color: "var(--text3)",
              fontFamily: "monospace",
              textAlign: "right"
            }}>
              {/* Adicionamos a empresa em destaque aqui */}
              <strong style={{ color: "#a78bfa", marginRight: 5 }}>{p.cnpj || "—"}</strong> 
              {p.created_at ? new Date(p.created_at).toLocaleString("pt-BR") : "—"}
            </span>
          </div>    
          <p style={{fontSize:9,letterSpacing:3,color:"var(--text5)",margin:"0 0 8px"}}>
            ESTOQUE FÍSICO
          </p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8,marginBottom:8}}>
            {LOCATIONS.map(k=>(
              <div key={k} style={{background:"var(--bg)",border:`1px solid ${(p[LOC_KEY[k]]||0)===0?"#55555533":LOC_COLOR[k]+"33"}`,borderRadius:2,padding:"10px 12px",display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
                <span style={{fontSize:9,letterSpacing:2,color:(p[LOC_KEY[k]]||0)===0?"var(--text4)":LOC_COLOR[k],fontWeight:700}}>{LOC_LABEL[k]}</span>
                <span style={{fontSize:22,fontWeight:700,fontFamily:"monospace",color:(p[LOC_KEY[k]]||0)===0?"var(--text4)":LOC_COLOR[k]}}>{p[LOC_KEY[k]]||0}</span>
                <span style={{fontSize:9,color:"var(--text4)"}}>un</span>
              </div>
            ))}
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 18px",borderTop:"1px solid var(--border)",flexWrap:"wrap",gap:8}}>
          <button style={{background:"none",border:"none",color:"var(--text4)",fontSize:9,letterSpacing:2,cursor:"pointer",display:"flex",alignItems:"center",gap:8}} onClick={()=>setOpen(v=>!v)}>
            {open?"▲ OCULTAR":"▼ HISTORICO"}<span style={{background:"var(--bg3)",color:"var(--text4)",fontSize:9,padding:"2px 6px",borderRadius:99}}>{p.movements.length}</span>
          </button>
          <div className="action-btns" style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            {user.role==="consultant"&&<ActionBtn onClick={()=>setTaskModal(true)} color="#00d084">◎ SOLICITAR</ActionBtn>}
            {user.role==="operator"&&<>
              <ActionBtn onClick={()=>setEditModal(true)} color="#3b82f6">✎ EDITAR</ActionBtn>
              <ActionBtn onClick={()=>setModal(true)} color="#ffa502">+ MOV.</ActionBtn>
            </>}
          </div>
        </div>
        {open&&(
          <div style={{borderTop:"1px solid var(--border)",padding:"10px 18px",display:"flex",flexDirection:"column",gap:6}}>
            {p.movements.length===0&&<p style={{color:"var(--text5)",fontSize:11,textAlign:"center",padding:16}}>Nenhuma movimentacao.</p>}
            {p.movements.map((mv,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"8px 10px",background:"var(--bg)",borderRadius:2,border:"1px solid var(--border)",flexWrap:"wrap"}}>
                <span style={{fontSize:9,padding:"3px 8px",borderRadius:2,background:MOV_COLOR(mv.type)+"20",color:MOV_COLOR(mv.type),fontWeight:700,whiteSpace:"nowrap"}}>{MOV_ICON(mv.type)} {MOV_LABEL(mv.type)}</span>
                {mv.type==="transferencia"?<div style={{display:"flex",alignItems:"center",gap:4}}>
                  <span style={{fontSize:9,padding:"2px 7px",border:`1px solid ${LOC_COLOR[mv.from]}44`,borderRadius:2,color:LOC_COLOR[mv.from],fontWeight:700}}>{LOC_LABEL[mv.from]||mv.from}</span>
                  <span style={{color:"#ffa502"}}>→</span>
                  <span style={{fontSize:9,padding:"2px 7px",border:`1px solid ${LOC_COLOR[mv.to]}44`,borderRadius:2,color:LOC_COLOR[mv.to],fontWeight:700}}>{LOC_LABEL[mv.to]||mv.to}</span>
                </div>:mv.location&&<span style={{fontSize:9,padding:"2px 7px",border:`1px solid ${LOC_COLOR[mv.location]}44`,borderRadius:2,color:LOC_COLOR[mv.location]||"#aaa",fontWeight:700}}>{LOC_LABEL[mv.location]||mv.location}</span>}
                <div style={{flex:1}}>
                  {mv.note&&<span style={{display:"block",fontSize:10,color:"var(--text3)"}}>{mv.note}</span>}
                  <span style={{fontSize:9,color:"var(--text5)"}}>por {mv.operator}</span>
                </div>
                <div style={{textAlign:"right"}}>
                  <span style={{display:"block",color:MOV_COLOR(mv.type),fontWeight:700,fontFamily:"monospace"}}>{mv.type==="saida"?"-":"+"}{mv.qty}</span>
                  <span style={{fontSize:9,color:"var(--text4)"}}>{fmtDate(mv.date)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {modal&&<MovModal product={p} user={user} onClose={()=>setModal(false)} onSave={saveMovement}/>}
      {editModal&&<EditModal product={p} onClose={()=>setEditModal(false)} onSave={saveEdit}/>}
      {taskModal&&<TaskRequestModal product={p} user={user} onClose={()=>setTaskModal(false)}/>}
    </>
  );
}


// ══════════════════════════════════════════════════════════════════════════════
// SLA — REGRAS AUTOMÁTICAS
// ══════════════════════════════════════════════════════════════════════════════
const SLA_RULES={
  "Em Separacao":   {maxHoras:24,  label:"Em Separação"},
  "Aguardando Despacho":{maxHoras:24,label:"Aguardando Despacho"},
  "Despachado":     {maxHoras:120, label:"Despachado"},   // 5 dias
};
const SLA_ROTA_HORAS=12;
const SLA_DEMANDA_HORAS=48;

function horasDiff(tsA,tsB){
  if(!tsA||!tsB)return 0;
  return Math.max(0,(new Date(tsB)-new Date(tsA))/(1000*3600));
}

// Retorna true se NF está fora do SLA
function nfForaSLA(nf){
  const rule=SLA_RULES[nf.status_logistico];
  if(!rule)return false;
  // Encontra o ts de entrada no status atual
  const entradas=nf.historico.filter(h=>h.status===nf.status_logistico);
  if(entradas.length===0)return false;
  const tsEntrada=entradas[entradas.length-1].ts;
  const horas=horasDiff(tsEntrada,new Date().toISOString());
  return horas>rule.maxHoras;
}

// Retorna horas desde a entrada no status atual
function nfHorasNoStatus(nf){
  const entradas=nf.historico.filter(h=>h.status===nf.status_logistico);
  if(entradas.length===0)return 0;
  const ts=entradas[entradas.length-1].ts;
  return horasDiff(ts,new Date().toISOString());
}

// Retorna horas de vida de uma rota (desde criada_em)
function rotaHorasAtiva(rota){
  if(rota.status==="FINALIZADA")return 0;
  return horasDiff(rota.criada_em,new Date().toISOString());
}

// Retorna horas de vida de uma demanda
function demandaHoras(task){
  if(task.status!=="pending")return 0;
  return horasDiff(task.date+"T00:00:00",new Date().toISOString());
}

// Calcula tempo médio entre dois status consecutivos — retorna horas ou null
function calcTempoMedio(nfs,statusDe,statusAte){
  const diffs=[];
  nfs.forEach(nf=>{
    const h=nf.historico;
    const aDe=h.filter(x=>x.status===statusDe);
    const aAte=h.filter(x=>x.status===statusAte);
    if(aDe.length>0&&aAte.length>0){
      const tsDe=new Date(aDe[aDe.length-1].ts);
      const tsAte=new Date(aAte[aAte.length-1].ts);
      if(tsAte>tsDe)diffs.push((tsAte-tsDe)/(1000*3600));
    }
  });
  if(diffs.length===0)return{media:null,count:0};
  return{media:diffs.reduce((a,b)=>a+b,0)/diffs.length,count:diffs.length};
}

function fmtHoras(h){
  if(h===null||h===undefined)return"—";
  if(h<1)return`${Math.round(h*60)}min`;
  if(h<24)return`${h.toFixed(1)}h`;
  return`${(h/24).toFixed(1)}d`;
}


function DashboardOperacional({nfs,rotas,tasks,products,deliveries,today,onSendReport}){

  // ── Métricas NFs ─────────────────────────────────────────────────────────
  const nfMetrics=useMemo(()=>{
    const byStatus={};
    STATUS_LOG.forEach(s=>{byStatus[s]=nfs.filter(n=>n.status_logistico===s).length;});
    const foraSlaCnt=nfs.filter(nfForaSLA).length;
    // Tempos médios entre etapas
    const etapas=[
      ["Faturado","Em Separacao"],
      ["Em Separacao","Aguardando Despacho"],
      ["Aguardando Despacho","Despachado"],
      ["Despachado","Entregue"],
    ];
    const tempos=etapas.map(([de,ate])=>({de,ate,...calcTempoMedio(nfs,de,ate)}));
    // Gargalo = etapa com maior tempo médio
    const withData=tempos.filter(t=>t.media!==null);
    const gargalo=withData.length>0?withData.reduce((a,b)=>a.media>b.media?a:b):null;
    return{byStatus,foraSlaCnt,tempos,gargalo};
  },[nfs]);

  // ── Métricas Rotas ───────────────────────────────────────────────────────
  const rotaMetrics=useMemo(()=>{
    const estaduais=rotas.filter(r=>r.tipo==="ESTADUAL");
    const hoje=estaduais.filter(r=>r.criada_em?.split("T")[0]===today);
    const finalizadasHoje=estaduais.filter(r=>r.finalizada_em?.split("T")[0]===today);
    const ativas=estaduais.filter(r=>r.status==="EM_ROTA");
    // Entregas hoje
    const entregasHoje=deliveries.filter(d=>d.date===today&&d.result==="ok").length;
    // Tempo médio de rota (início → fim)
    const duracoes=estaduais.filter(r=>r.horario_saida&&r.finalizada_em).map(r=>horasDiff(r.horario_saida,r.finalizada_em));
    const tempoMedioRota=duracoes.length>0?duracoes.reduce((a,b)=>a+b,0)/duracoes.length:null;
    return{criadasHoje:hoje.length,finalizadasHoje:finalizadasHoje.length,ativas:ativas.length,entregasHoje,tempoMedioRota};
  },[rotas,deliveries,today]);

  // ── Métricas Estoque ─────────────────────────────────────────────────────
  const estMetrics=useMemo(()=>{
    let capitalTotal=0;let criticos=0;let divergencias=0;let totalItens=0;
    products.forEach(p=>{
      const sys=totalSys(p);
      totalItens+=sys;
      if(p.price>0)capitalTotal+=sys*p.price;
      if(sys<=3)criticos++;
      const diff=p.fisico-sys;
      if(diff!==0)divergencias++;
    });
    return{total:products.length,totalItens,criticos,divergencias,capitalTotal};
  },[products]);

  // ── Alertas ──────────────────────────────────────────────────────────────
  const alertas=useMemo(()=>{
    const list=[];
    // NFs fora SLA
    nfs.filter(nfForaSLA).forEach(nf=>{
      const rule=SLA_RULES[nf.status_logistico];
      list.push({tipo:"sla",cor:"#ff4757",icon:"⏰",msg:`NF ${nf.numero_nf} — ${STATUS_LOG_LABEL[nf.status_logistico]||nf.status_logistico} há mais de ${rule?.maxHoras}h`,id:nf.id});
    });
    // Rotas abertas > 12h ou não finalizadas no mesmo dia
    rotas.filter(r=>r.tipo==="ESTADUAL"&&r.status==="EM_ROTA").forEach(r=>{
      const h=rotaHorasAtiva(r);
      if(h>SLA_ROTA_HORAS)list.push({tipo:"rota",cor:"#ffa502",icon:"⊞",msg:`Rota ${r.codigo} ativa há ${fmtHoras(h)}`,id:r.id});
    });
    // Demandas > 48h
    tasks.filter(t=>t.status==="pending"&&demandaHoras(t)>SLA_DEMANDA_HORAS).forEach(t=>{
      list.push({tipo:"demanda",cor:"#ffa502",icon:"◎",msg:`Demanda "${t.taskLabel}" de ${t.requestedBy} pendente há mais de 48h`,id:t.id});
    });
    // Produtos com divergência
    products.filter(p=>{const d=p.fisico-totalSys(p);return d!==0;}).slice(0,5).forEach(p=>{
      const d=p.fisico-totalSys(p);
      list.push({tipo:"estoque",cor:"#ff4757",icon:"▣",msg:`${p.sku} — divergência de ${d>0?"+":""}${d} un`,id:p.sku});
    });
    return list;
  },[nfs,rotas,tasks,products]);

  const DBlock=({titulo,cor="#ffa502",children})=>(
    <div style={{marginBottom:28}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
        <div style={{width:3,height:14,background:cor,borderRadius:2,flexShrink:0}}/>
        <p style={{fontSize:9,letterSpacing:3,color:cor,fontWeight:700}}>{titulo}</p>
      </div>
      {children}
    </div>
  );

  const SC2=({label,value,color="#ffa502",sub,highlight})=>(
    <div style={{background:"var(--bg2)",border:`1px solid ${highlight?"#ffd70055":color+"33"}`,borderRadius:2,padding:"14px 16px",position:"relative",overflow:"hidden"}}>
      {highlight&&<div style={{position:"absolute",top:0,left:0,right:0,height:2,background:"#ffd700"}}/>}
      <p style={{fontSize:8,letterSpacing:2,color:"var(--text4)",marginBottom:6}}>{label}</p>
      <p style={{fontSize:highlight?28:24,fontWeight:700,color:highlight?"#ffd700":color,fontFamily:"monospace",lineHeight:1}}>{value}</p>
      {sub&&<p style={{fontSize:8,color:"var(--text4)",marginTop:5,letterSpacing:1}}>{sub}</p>}
    </div>
  );

  return(
    <div>
      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24,flexWrap:"wrap",gap:10}}>
        <div>
          <h2 style={{fontSize:12,letterSpacing:4,color:"var(--text)",fontWeight:700,marginBottom:3}}>PAINEL OPERACIONAL</h2>
          <p style={{fontSize:9,color:"var(--text4)",letterSpacing:1}}>Hoje: {fmtDate(today)}</p>
        </div>
        <button onClick={onSendReport} style={{background:"none",border:"1px solid #ffa50244",color:"#ffa502",padding:"6px 14px",fontSize:9,letterSpacing:2,cursor:"pointer",borderRadius:2,fontFamily:"'Courier New',monospace"}}>
          ✉ ENVIAR RELATÓRIO
        </button>
      </div>

      {/* BLOCO D — ALERTAS (primeiro se houver) */}
      {alertas.length>0&&(
        <div style={{background:"#ff475708",border:"1px solid #ff475733",borderRadius:2,padding:"14px 16px",marginBottom:24}}>
          <p style={{fontSize:9,letterSpacing:3,color:"#ff4757",fontWeight:700,marginBottom:12}}>⚠ ALERTAS OPERACIONAIS — {alertas.length}</p>
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            {alertas.map((a,i)=>(
              <div key={i} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"8px 0",borderBottom:i<alertas.length-1?"1px solid #ff475718":"none"}}>
                <span style={{fontSize:14,flexShrink:0,marginTop:1}}>{a.icon}</span>
                <p style={{fontSize:10,color:a.cor,lineHeight:1.4}}>{a.msg}</p>
              </div>
            ))}
          </div>
        </div>
      )}
      {alertas.length===0&&(
        <div style={{background:"#00d08408",border:"1px solid #00d08433",borderRadius:2,padding:"12px 16px",marginBottom:24,display:"flex",alignItems:"center",gap:10}}>
          <span style={{color:"#00d084",fontSize:16}}>✓</span>
          <p style={{fontSize:10,color:"#00d084",letterSpacing:1}}>Operação dentro da normalidade.</p>
        </div>
      )}

      {/* Gargalo */}
      {nfMetrics.gargalo&&(
        <div style={{background:"#ffa50210",border:"1px solid #ffa50233",borderRadius:2,padding:"10px 16px",marginBottom:24,display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
          <span style={{fontSize:9,letterSpacing:3,color:"#ffa502",fontWeight:700,flexShrink:0}}>GARGALO ATUAL</span>
          <span style={{fontSize:11,color:"var(--text)",fontWeight:600}}>{STATUS_LOG_LABEL[nfMetrics.gargalo.de]||nfMetrics.gargalo.de} → {STATUS_LOG_LABEL[nfMetrics.gargalo.ate]||nfMetrics.gargalo.ate}</span>
          <span style={{fontSize:10,color:"#ffa502",fontWeight:700,marginLeft:"auto"}}>média {fmtHoras(nfMetrics.gargalo.media)}</span>
          <span style={{fontSize:8,color:"var(--text5)",letterSpacing:1}}>Baseado em {nfMetrics.gargalo.count} NF(s)</span>
        </div>
      )}

      {/* BLOCO A — NFs */}
      <DBlock titulo="A — OPERAÇÃO LOGÍSTICA (NFs)" cor="#f97316">
        <div className="dash-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(155px,1fr))",gap:8,marginBottom:14}}>
          {STATUS_LOG.filter(s=>s!=="Em Rota").map(s=>{
            const foraCount=nfs.filter(n=>n.status_logistico===s&&nfForaSLA(n)).length;
            return(
              <div key={s} style={{background:"var(--bg2)",border:`1px solid ${STATUS_LOG_COLOR[s]||"#aaa"}33`,borderRadius:2,padding:"12px 14px",position:"relative"}}>
                {foraCount>0&&<span style={{position:"absolute",top:6,right:6,background:"#ff4757",color:"#fff",fontSize:7,padding:"1px 5px",borderRadius:99,fontWeight:700}}>SLA ✗{foraCount}</span>}
                <p style={{fontSize:8,letterSpacing:2,color:"var(--text4)",marginBottom:6,paddingRight:foraCount>0?36:0}}>{STATUS_LOG_LABEL[s]||s}</p>
                <p style={{fontSize:24,fontWeight:700,color:STATUS_LOG_COLOR[s]||"#aaa",fontFamily:"monospace",lineHeight:1}}>{nfMetrics.byStatus[s]||0}</p>
              </div>
            );
          })}
          <div style={{background:"var(--bg2)",border:"1px solid #ff475733",borderRadius:2,padding:"12px 14px"}}>
            <p style={{fontSize:8,letterSpacing:2,color:"var(--text4)",marginBottom:6}}>FORA DO SLA</p>
            <p style={{fontSize:24,fontWeight:700,color:nfMetrics.foraSlaCnt>0?"#ff4757":"#00d084",fontFamily:"monospace",lineHeight:1}}>{nfMetrics.foraSlaCnt}</p>
          </div>
        </div>
        {/* Tempos médios */}
        <p style={{fontSize:8,letterSpacing:3,color:"var(--text5)",marginBottom:8}}>TEMPO MÉDIO POR ETAPA</p>
        <div className="dash-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:6}}>
          {nfMetrics.tempos.map(t=>(
            <div key={t.de+t.ate} style={{background:"var(--bg)",border:"1px solid var(--border)",borderRadius:2,padding:"8px 12px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <p style={{fontSize:9,color:"var(--text4)",lineHeight:1.4}}>{STATUS_LOG_LABEL[t.de]||t.de} → {STATUS_LOG_LABEL[t.ate]||t.ate}</p>
              <div style={{textAlign:"right",flexShrink:0,marginLeft:8}}>
                <p style={{fontSize:12,fontWeight:700,color:t.media!=null?"var(--text)":"var(--text4)",fontFamily:"monospace"}}>{fmtHoras(t.media)}</p>
                {t.count>0&&<p style={{fontSize:7,color:"var(--text5)"}}>{t.count} NF(s)</p>}
              </div>
            </div>
          ))}
        </div>
      </DBlock>

      {/* BLOCO B — Rotas/Entregador */}
      <DBlock titulo="B — OPERAÇÃO DO ENTREGADOR (ROTAS ESTADUAIS)" cor="#3b82f6">
        <div className="dash-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(155px,1fr))",gap:8}}>
          <SC2 label="CRIADAS HOJE" value={rotaMetrics.criadasHoje} color="#ffa502"/>
          <SC2 label="FINALIZADAS HOJE" value={rotaMetrics.finalizadasHoje} color="#00d084"/>
          <SC2 label="ROTAS ATIVAS" value={rotaMetrics.ativas} color="#3b82f6"/>
          <SC2 label="ENTREGAS HOJE" value={rotaMetrics.entregasHoje} color="#00d084"/>
          <SC2 label="TEMPO MÉDIO ROTA" value={fmtHoras(rotaMetrics.tempoMedioRota)} color="#3b82f6" sub={rotaMetrics.tempoMedioRota!=null?"início → finalização":""}/>
        </div>
      </DBlock>

      {/* BLOCO C — Estoque */}
      <DBlock titulo="C — CONTROLE DE ESTOQUE & CAPITAL IMOBILIZADO" cor="#00d084">
        <div className="dash-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(155px,1fr))",gap:8,marginBottom:12}}>
          <SC2 label="PRODUTOS CADASTRADOS" value={estMetrics.total} color="#3b82f6"/>
          <SC2 label="ITENS FÍSICOS NO SISTEMA" value={estMetrics.totalItens} color="#3b82f6"/>
          <SC2 label="ESTOQUE CRÍTICO (≤3)" value={estMetrics.criticos} color={estMetrics.criticos>0?"#ff4757":"#00d084"}/>
          <SC2 label="DIVERGÊNCIAS FÍSICO/SISTEMA" value={estMetrics.divergencias} color={estMetrics.divergencias>0?"#ffa502":"#00d084"}/>
        </div>
        {/* Capital imobilizado — destaque */}
        <div style={{background:"var(--bg)",border:"2px solid #ffd70055",borderRadius:4,padding:"18px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
          <div>
            <p style={{fontSize:8,letterSpacing:3,color:"#ffd700",fontWeight:700,marginBottom:6}}>CAPITAL IMOBILIZADO EM ESTOQUE</p>
            <p style={{fontSize:32,fontWeight:700,color:"#ffd700",fontFamily:"monospace",lineHeight:1}}>
              R$ {estMetrics.capitalTotal.toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2})}
            </p>
          </div>
          <div style={{textAlign:"right"}}>
            <p style={{fontSize:9,color:"var(--text4)",marginBottom:2}}>{estMetrics.total} produtos</p>
            <p style={{fontSize:9,color:"var(--text4)"}}>{estMetrics.totalItens} unidades</p>
          </div>
        </div>
      </DBlock>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// AUDITORIA TAB
// ══════════════════════════════════════════════════════════════════════════════

export { MovModal, EditModal, TaskRequestModal, ResolveTaskModal, TasksPanel, RefreshModal, NewProductModal, Card, DashboardOperacional }